import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnInit,
    QueryList,
    ViewChild,
    ViewChildren,
    EventEmitter,
    Output,
    Input,
    OnChanges,
    SimpleChanges,
    Renderer2,
} from '@angular/core';
import {
    AbstractControl,
    FormArray,
    FormControl,
    FormGroup,
    UntypedFormArray,
    UntypedFormBuilder,
    UntypedFormControl,
    UntypedFormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators,
} from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { controlTypes } from 'src/app/Modules/management/enums/controlsType';
import { IceapiService, IdmApiService, ManagementApiService, UserUtilityService } from 'src/app/services';
import { CalculationType } from 'src/app/Modules/informate/enums/calculation-type.enum';
import { JointCalculationModelComponent } from '../joint-calculation-model/joint-calculation-model.component';
import { ImageCropModelComponent } from '../image-crop-model/image-crop-model.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { PlantmanagerService } from 'src/app/Modules/idms/components/plant-manager/services/plantmanager.service';
import { ConnectorChild, ImageDatas, PlantList, SaveTaggedItemData } from 'src/app/Modules/idms/components/plant-manager/models/plant-manager.model';
import { PageType } from 'src/app/Modules/idms/enums/PageType';
import { IdmsSharedService } from 'src/app/Modules/idms/services/idms-shared.service';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { CalculationResult, GeneralOutput, InputGroup, ToolOutput, Warnings } from 'src/app/Modules/informate/models/calculationModels';
import { DocumentApiService } from 'src/app/services/document-api.service';
import { JointTighteningGenericComponent } from '../joint-tightening-generic/joint-tightening-generic.component';
import { JointCalcService, PipeSpecpayload } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';
import { DataService } from 'src/app/services/data.service';
import { ProjectsDetails } from 'src/app/Modules/idms/components/project-manager/models/projectDetails.model';
import { ProjectActivityPackDetails } from 'src/app/Modules/idms/components/project-manager/models/ProjectActivityPackDetails.model';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { tighteningDetails } from 'src/app/Modules/management/models/organization/tighteningDetails';
import { TighteningMethod } from 'src/app/Modules/informate/enums/tightening-method.enum';
import { MatSelectChange } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectmanagerService } from 'src/app/Modules/idms/components/project-manager/services/projectmanager.service';
import { SettingArea } from 'src/app/Modules/settings/models/common/setting-area.model';
import { DefaultInstanceSettings, InstanceSettings } from 'src/app/Modules/management/models/instance/instace-setting.model';
import { userSelectionValidator } from 'src/app/Modules/management/core/Validators/userSelectCheck.validator';
import { CustomValidatorService } from 'src/app/services/custom-validator.service';
import { DiagramDataModel, DiagramInfo } from 'src/app/Modules/informate/models';
import { finalize, Subscription } from 'rxjs';
import { MatSelectionListChange } from '@angular/material/list';
export interface ResultObj {
    key: string;
    type: string;
    alias: string;
    Placeholder: string;
    ismask: boolean;
    mask: string;
    maskValue: any;
    DecimalPlaces: any;
    excludedunits: any;
    UnitType: string;
    DisplayUnit: any;
    validators: any;
    selections: any;
    Default: string;
    isnameprimary?: boolean;
    IsNameSecondary?: boolean;
    imageoption?: string;
    scopekey?: string;
    apikey?: string;
    parameters?: string;
    userList: any[];
    userListSearch: any[];
    datetype: string;
}
export class Tabs {
    key: string;
    alias: string;
    type: string;
    sections: Section[];
}
export class Section {
    key: string;
    alias: string;
    type: string;
    groups: Groups[];
}
export interface Groups {
    key: string;
    alias: string;
    type: string;
    fields: Fields[];
}
export interface Controls {
    key: string;
    alias: string;
    type: string;
    fields: Fields[];
}

export interface Fields {
    fields: any;
    key: string;
    alias: string | string[];
    type: string;
    default?: any;
    isnameprimary?: boolean;
    IsNameSecondary?: boolean;
    validators?: Validator[];
    parameters?: any;
    selections?: any;
    scopekey?: any;
    // dbselectkey?:string;
}

export interface Validator {
    key: string;
    value: any;
    message: string;
}
export const MY_FORMATS = {
    parse: {
        dateInput: 'YYYY/MM/DD',
    },
    display: {
        dateInput: 'YYYY/MM/DD',
        monthYearA11yLabel: 'YYYY',
        monthYearLabel: 'MM',
        dateA11yLabel: 'LL',
    },
};
@Component({
    selector: 'app-dynamic-controls',
    templateUrl: './dynamic-controls.component.html',
    styleUrls: ['./dynamic-controls.component.scss'],
})
export class DynamicControlsComponent implements OnInit, OnChanges {
    @Input() DataContent: string;
    @Input() jsonString: string;
    @Input() PageType: string;
    @Input() mode: string;
    @Input() pagetitle: string;
    @Input() permission: boolean;
    ///For Plant Manager Create /Edit
    // @Input() TaggedItemData: PlantList;
    @Input()
    set TaggedItemData(value: PlantList) {
        this._taggedItem = value;
    }
    get TaggedItemData(): PlantList {
        return this._taggedItem;
    }

    @Input() selectedConnectorChild: ConnectorChild;
    @Input() projectDetails: ProjectsDetails;
    @Input() activityPackDetails: ProjectActivityPackDetails;
    @Input() schemsForm: UntypedFormGroup;
    @Input() AdditionalInfo: any;
    @Input() Tab: number;
    @Input() selectedTool: ToolOutput;
    @Input() trail: any;
    @Input() isSave: boolean = false;
    @Input() pipeSpecVerId: string;

    @Output() SavePlantManager = new EventEmitter<SaveTaggedItemData>();
    @Output() saveProjectmanager = new EventEmitter<SaveTaggedItemData>();
    @Output() fncalculationResult = new EventEmitter<string>();
    @ViewChild('CheckList') checkedList: HTMLElement;
    @ViewChildren('fileInput') fileInputs: QueryList<any>;
    @ViewChild('imageUpload') imageUpload: ElementRef<HTMLInputElement>;
    @Input() activityPackRecordDetails: any;
    _taggedItem: PlantList;
    settingArea: SettingArea;
    jointIdSetting: any;
    jointIdPrefixValue: DefaultInstanceSettings;

    isSaveEnable: boolean = false;
    selectedTabIndex = 0;
    AlignmentData = {
        studboltsreplaced: false,
        gasketreplaced: false,
        flangefacerepairrequired: false,
        paintundernutremoved: false,
        correctstud: false,
        studscorrectlylubricated: false,
        datalist: [
            {
                name: 'centreline',
                zerodrg: '00',
                ninetydrg: '00',
                oneeightydrg: '00',
                twoseventydrg: '00',
            },
            {
                name: 'separation',
                zerodrg: '00',
                ninetydrg: '00',
                oneeightydrg: '00',
                twoseventydrg: '00',
            },
            {
                name: 'gap',
                zerodrg: '00',
                ninetydrg: '00',
                oneeightydrg: '00',
                twoseventydrg: '00',
            },
            {
                name: 'rotational',
                zerodrg: '00',
                ninetydrg: '00',
                oneeightydrg: '00',
                twoseventydrg: '00',
            },
        ],
    };

    jsonObject: Section[] | Tabs[];
    jsonObjectCopy = [];
    controlTypes = controlTypes;
    resultObj;
    checkboxListArray = [];
    lineNumberFormet = [];
    lineNumberFormetSection = [];
    lineNumberFormatId: string;
    pipeSpecVersionId: string;
    checkListSet = new Map();
    dbSelectValues = [];
    calcType: CalculationType = -1;
    uploadedFiles: any[] = [];
    messageService: any;
    imageChangedEvent: any = '';
    images: any = [];
    imageUrl: string;
    imageSelected: boolean = false;
    url: any;
    selectedImage: File | '';
    _jsonString: any;
    JsonDataContent: any;
    SaveText: string = 'Save';
    PlantManagerSaveObj: SaveTaggedItemData;
    IsVersionUpgrade: boolean = false;
    showPrint: boolean = false;
    calcResult: CalculationResult;
    IsPlantManangerPage: boolean;
    speedValue = 0;
    color = '#ccc';
    selectedMUnit: string = '';
    IsLeakOrExceptionVersionUpgrade: boolean = false;
    showJointtighteningBtn: boolean = false;
    barCodeNumber: string;
    projectName: string;
    workpackName: string;
    jointIdName: string;
    warningMesaages: any;
    activitypackTypeStatus: string;
    torqueUnitOptions = [
        { label: 'Nm', value: 'Nm' },
        { label: 'Lbf.ft', value: 'Lbf.ft' },
    ];
    TensionUnitOptions = [
        { label: 'Bar', value: 'Bar' },
        { label: 'PSI', value: 'PSI' },
    ];
    stateOptions = [
        { label: 'Torque', value: 'Torque' },
        { label: 'Tension', value: 'Tension' },
    ];

    UnitTypeArray = [
        { key: 'Length', units: ['mm', 'in'] },
        { key: 'Stress', units: ['Mpa', 'Psi', 'Bar'] },
        { key: 'Pressure', units: ['	Mpa', 'Psi', 'Bar', 'Bar(g)'] },
        { key: 'Force', units: ['N', 'Lbf', '	Kn'] },
        { key: 'Temperature', units: ['°C', '°F'] },
        { key: 'Percentage', units: ['%'] },
        { key: 'Torque', units: ['NM', 'Lbf.ft'] },
        { key: 'Angle', units: ['°'] },
        { key: 'LubricantMu', units: ['μ'] },
        { key: 'LubricantK', units: ['K'] },
        { key: 'Electrical', units: ['Ω', 'A'] },
        { key: 'Volume', units: ['m³', 'Scf'] },
    ];

    selectedToolId: string;
    selectedTorqueUnit: string;
    selectedTensionUnit: string;
    tighteningMethod: number;
    resBoltStress: string;
    PumpPressurepassValues: any;
    TorquePassValues: any;
    ToolingValue: boolean = true;
    startdate: any;
    enddate: any;
    isjointcalcOpen: boolean = false;
    selectedLineNumberFormate: any;
    ToolingWarning: string;
    isJointCalculationAvailable: boolean = false;
    private updateSchemasubscription: Subscription;
    private calculationResultUpdatesubscription: Subscription;
    private isSaveFromToolsubscription: Subscription;
    isLoading: boolean = false;
    isToolChanged: boolean = false;
    general: GeneralOutput = null;
    displayIDMSSettings: boolean = false;
    isWorkPackPage: boolean = false;

    linenumberControlname = 'linenumber';
    @ViewChild('sliderRef', { static: false }) slider!: any;

    constructor(
        private ngbActiveModal: NgbActiveModal,
        private formBuilder: UntypedFormBuilder,
        private managementApiService: ManagementApiService,
        private user_utlity: UserUtilityService,
        private idmApiService: IdmApiService,
        private modelService: NgbModal,
        private cd: ChangeDetectorRef,
        private ngxUiLoaderService: NgxUiLoaderService,
        private plantmanagerService: PlantmanagerService,
        private idmsSharedService: IdmsSharedService,
        private globalEmittersService: GlobalEmittersService,
        private documentApiService: DocumentApiService,
        private jointCalcService: JointCalcService,
        private dataservice: DataService,
        private customToastService: CustomToastService,
        private router: Router,
        private projectmanagerService: ProjectmanagerService,
        private customValidatorService: CustomValidatorService,
        private iceApiService: IceapiService,
        private renderer: Renderer2,
        private route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        // 🔹 Get route params
        const projectId = this.route.snapshot.paramMap.get('projectId');
        const workpackId = this.route.snapshot.paramMap.get('id');

        // 🔹 Get query param
        const index = this.route.snapshot.queryParamMap.get('index');
        if (projectId && workpackId && index === '0') {
            this.isWorkPackPage = true;
        } else {
            this.isWorkPackPage = false;
        }
        this.SaveText = this.PageType == PageType.PlantManagerCopy ? 'Copy and Create Tagged Item' : this.Tab == 1 ? 'Next' : this.SaveText;
        // this.ngxUiLoaderService.start();
        if (this.mode == 'pop-up') this.setUpAndInitControls();
        this.intilizationAndSubscription();
        if (this.trail) {
            for (const item of this.trail) {
                if (item.hasOwnProperty('type')) {
                    if (item.type === 'ActivityPackTypeStatus') {
                        this.activitypackTypeStatus = item.name;

                        if (this.permission) {
                            this.pagetitle = 'Edit Activity Record - ' + this.activitypackTypeStatus;
                        } else {
                            this.pagetitle = 'View Activity Record - ' + this.activitypackTypeStatus;
                        }
                    }
                } else {
                    this.pagetitle = 'Activity Record';
                }

                if (item.hasOwnProperty('entityType')) {
                    if (item.entityType === 'Project') {
                        this.projectName = item.name;
                    } else if (item.entityType === 'ActivityPack') {
                        this.workpackName = item.name;
                    } else if (item.entityType === 'TaggedItem') {
                        this.jointIdName = item.name;
                    }
                }
            }
        } else {
            if (this.projectmanagerService && this.projectmanagerService?.selectedProjectData?.namePrimary) {
                this.projectName = this.projectmanagerService?.selectedProjectData?.namePrimary;
            }

            if (this.projectmanagerService && this.projectmanagerService?.selectedWorkpackdata?.namePrimary) {
                this.workpackName = this.projectmanagerService?.selectedWorkpackdata?.namePrimary;
            }
        }

        this.calculationResultUpdatesubscription = this.globalEmittersService.calculationResultUpdate.subscribe((res) => {
            if (res) {
                //this.calcResult = res;
                this.calcResult = res;
                this.PlantManagerSaveObj.CalculationResult = res;
                this.cd.detectChanges();
                this.globalEmittersService.calculationResultUpdate.next(null);
            }
        });
        this.isSaveFromToolsubscription = this.globalEmittersService.isSaveFromToolsubscription.subscribe((res) => {
            if (res && this.router.url.includes('/idms/plantmanagerView')) {
                //this.calcResult = res;
                if (this.plantmanagerService.saveAfterToolSelection) {
                    this.isSave = false;
                    this.plantmanagerService.saveAfterToolSelection = false;
                    this.submitItem();
                }
                //else this.setUpAndInitControls();
            }
        });
    }

    ngAfterViewInit(): void {
        if (
            (this.PlantManagerSaveObj &&
                ((this.PageType as PageType) === PageType.EditLeakItem || (this.PageType as PageType) === PageType.EditExceptionItem)) ||
            (this.PageType as PageType) === PageType.ExceptionEditWithLatestSchema ||
            (this.PageType as PageType) === PageType.LeakEditWithLatestSchema
        ) {
            this.PlantManagerSaveObj.Tab = this.Tab;
            this.PlantManagerSaveObj.schemsForm = this.schemsForm;
            this.PlantManagerSaveObj.images = this.images;
            this.PlantManagerSaveObj.TaggedItemData = this.TaggedItemData;
            this.PlantManagerSaveObj.GroupType = this.jsonObject[0].type;
            this.PlantManagerSaveObj.PageType = this.PageType;
            this.PlantManagerSaveObj.schemaVersionId =
                this.Tab == 1 ? this.AdditionalInfo.DetailsSchemaVersionId : this.AdditionalInfo.LeakOrExceptionschemaVersionId;
            this.PlantManagerSaveObj.IsSave = false;
            this.PlantManagerSaveObj.AdditionalInfo = this.AdditionalInfo;
        }
        if (
            (this.PageType as PageType) === PageType.EditLeakItem ||
            (this.PageType as PageType) === PageType.AddLeakItem ||
            (this.PageType as PageType) === PageType.EditExceptionItem ||
            (this.PageType as PageType) === PageType.AddExceptionItem ||
            (this.PageType as PageType) === PageType.ExceptionEditWithLatestSchema ||
            (this.PageType as PageType) === PageType.LeakEditWithLatestSchema
        ) {
            let FormData = {
                schemsForm: this.schemsForm,
                Tab: this.Tab,
                PlantManagerSaveObj: this.PlantManagerSaveObj,
            };
            // this.plantmanagerService.LeakOrExceptionFormGroups.next(FormData);
            this.idmsSharedService.updateFormException(FormData);
        }
        this.ngxUiLoaderService.stop();

        if (this.AdditionalInfo?.ActivityPackStatus == 'Complete' && this.slider) {
            const hostElement = this.slider?.element?.nativeElement as HTMLElement;
            const handle = hostElement.querySelector('.dx-slider-handle');
            this.renderer.addClass(handle, 'no-drag');
        }
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (this.isSave && this.plantmanagerService.saveAfterToolSelection) {
            this.isSave = false;
            this.plantmanagerService.saveAfterToolSelection = false;
            this.submitItem();
        } else {
            if (this.mode != 'pop-up') this.setUpAndInitControls();
        }
        // this.cd.detectChanges();

        if (this.pipeSpecVerId) {
            this.pipeSpecVersionId = this.pipeSpecVerId;
        }
    }

    intilizationAndSubscription() {
        if (
            this.PageType == PageType.PlantManagerEdit ||
            this.PageType == PageType.ProjectManagerEdit ||
            this.PageType == PageType.ActivityPackEdit ||
            this.PageType == PageType.EditActivityTaggedItem
        ) {
            this.updateSchemasubscription = this.plantmanagerService.updatedSchema.subscribe((res: string) => {
                if (res) {
                    this.jsonString = res;
                    this.IsVersionUpgrade = false;

                    if (this.PageType == PageType.PlantManagerEdit) this.PageType = PageType.PlantManagerEditWithLatestSchema;
                    if (this.PageType == PageType.ProjectManagerEdit) this.PageType = PageType.ProjectManagerEditWithLatestSchema;
                    if (this.PageType == PageType.ActivityPackEdit) this.PageType = PageType.ActivityPackEditWithLatestSchema;
                    if (this.PageType == PageType.EditActivityTaggedItem) this.PageType = PageType.ActivityTaggedItemEditWithLatestSchema;
                    this.setUpAndInitControls();
                    this.schemsForm.markAsDirty();
                    this.schemsForm.markAsTouched();
                    this.plantmanagerService.updatedSchema.next(null);
                }
            });
            //
            this.plantmanagerService.updateFormAfterCalculation.subscribe((res: boolean) => {
                if (res && this.schemsForm) {
                    this.schemsForm.markAsDirty();
                    this.schemsForm.markAllAsTouched();
                }
            });
        }
        if (
            (this.PageType as PageType) === PageType.EditLeakItem ||
            (this.PageType as PageType) === PageType.AddLeakItem ||
            (this.PageType as PageType) === PageType.EditExceptionItem ||
            (this.PageType as PageType) === PageType.AddExceptionItem ||
            (this.PageType as PageType) === PageType.ExceptionEditWithLatestSchema ||
            (this.PageType as PageType) === PageType.LeakEditWithLatestSchema
        ) {
            this.schemsForm.valueChanges.subscribe((value) => {
                this.PlantManagerSaveObj.GroupType = this.jsonObject[0].type;
                this.PlantManagerSaveObj.PageType = this.PageType;
                this.PlantManagerSaveObj.schemaVersionId =
                    this.Tab == 1 ? this.AdditionalInfo.DetailsSchemaVersionId : this.AdditionalInfo.LeakOrExceptionschemaVersionId;
                let FormData = {
                    schemsForm: this.schemsForm,
                    Tab: this.Tab,
                    PlantManagerSaveObj: this.PlantManagerSaveObj,
                };

                // this.plantmanagerService.LeakOrExceptionFormGroups.next(FormData);
                this.idmsSharedService.updateFormException(FormData);
                // this.cd.detectChanges();
            });

            this.plantmanagerService.updateForm.subscribe((res: any) => {
                if (res) {
                    if (this.Tab == 2) {
                        this.schemsForm.markAsDirty();
                        this.schemsForm.markAsTouched();
                        this.cd.detectChanges();
                        this.plantmanagerService.updateForm.next(null);
                    }
                }
            });
        }
    }

    setUpAndInitControls() {
        this.PlantManagerSaveObj = {
            schemsForm: this.schemsForm,
            CalculationResult: '',
            GroupType: '',
            images: this.images,
            ImageUrl: this.imageUrl,
            NamePrimaryKey: '',
            NameSecondaryKey: '',
            selectedConnectorChild: null,
            imageKey: '',
            TaggedItemData: null,
            taggedItemType: '',
            schemaVersionId: null,
            dateTypeKey: [],
            Tab: null,
            IsImageChanged: false,
            userSelectKey: [],
        };
        if (
            this.PageType == PageType.PlantManagerCreate ||
            this.PageType == PageType.PlantManagerEdit ||
            this.PageType == PageType.PlantManagerEditWithLatestSchema ||
            this.PageType == PageType.PlantManagerCopy
        ) {
            this.IsPlantManangerPage = true;
            if (
                this.TaggedItemData &&
                (this.PageType == PageType.PlantManagerEdit ||
                    this.PageType == PageType.PlantManagerEditWithLatestSchema ||
                    this.PageType == PageType.PlantManagerCopy)
            ) {
                //For Edit
                this.PlantManagerSaveObj.taggedItemType = this.TaggedItemData?.taggedItemType;
                if (
                    this.TaggedItemData.latestSchemaVersionId != this.TaggedItemData.schemaVersionId &&
                    (this.PageType as PageType) == PageType.PlantManagerEdit
                ) {
                    this.IsVersionUpgrade = true;
                }
            } //For Create
            else this.PlantManagerSaveObj.taggedItemType = this.selectedConnectorChild?.taggedItemType;
        }
        if (
            (this.PageType == PageType.EditLeakItem ||
                this.PageType == PageType.EditExceptionItem ||
                (this.PageType as PageType) === PageType.ExceptionEditWithLatestSchema ||
                (this.PageType as PageType) === PageType.LeakEditWithLatestSchema) &&
            ((this.Tab == 1 && this.AdditionalInfo?.latestDetailsSchema) || (this.Tab == 2 && this.AdditionalInfo?.latestLeakOrExceptionSchema))
        ) {
            this.IsLeakOrExceptionVersionUpgrade = true;
        }
        this.jsonObject = this.idmsSharedService.convertKeysToLowerCase(JSON.parse(this.jsonString));

        try {
            if (this.DataContent) this.JsonDataContent = JSON.parse(this.DataContent.replace("')", ''));
        } catch (error) {}

        if (
            this.PageType == PageType.PlantManagerCreate ||
            this.PageType == PageType.PlantManagerEdit ||
            this.PageType == PageType.PlantManagerEditWithLatestSchema ||
            this.PageType == PageType.PlantManagerCopy
        ) {
            if (
                this.JsonDataContent?.jointcalculation &&
                this.JsonDataContent?.jointcalculation != '0' &&
                this.JsonDataContent?.jointcalculation != 'null' &&
                this.JsonDataContent?.jointcalculation != 'undefined'
            ) {
                if (this.JsonDataContent?.jointcalculation?.length > 20) {
                    this.globalEmittersService.ShowFlangeDetailsTab.next(true);
                } else {
                    this.globalEmittersService.ShowFlangeDetailsTab.next(false);
                    //To reset  flange details tab
                    this.globalEmittersService.calculationResult.next(null);
                }
            } else {
                this.globalEmittersService.ShowFlangeDetailsTab.next(false);
                //To reset  flange details tab
                this.globalEmittersService.calculationResult.next(null);
            }
        }
        if (
            this.projectDetails &&
            this.projectDetails.schemaVersion.latestSchemaVersionId != this.projectDetails.schemaVersion.schemaVersionId &&
            (this.PageType as PageType) == PageType.ProjectManagerEdit
        ) {
            this.IsVersionUpgrade = true;
        }
        if (
            this.activityPackDetails &&
            this.activityPackDetails.schemaVersion.latestSchemaVersionId != this.activityPackDetails.schemaVersion.schemaVersionId &&
            (this.PageType as PageType) == PageType.ActivityPackEdit
        ) {
            this.IsVersionUpgrade = true;
        }
        if (
            this.activityPackRecordDetails &&
            this.activityPackRecordDetails.activityPackTaggedItemActivityLatestSchemaVersionId !=
                this.activityPackRecordDetails.activityPackTaggedItemActivitySchemaVersionId &&
            (this.PageType as PageType) == PageType.EditActivityTaggedItem
        ) {
            this.IsVersionUpgrade = true;
        }

        if (this.jsonObject) {
            this.MakingNewObjectforControls();
            this.schemsForm = this.formBuilder.group({});
            this.initFormControls();
            if (this.DataContent) this.setFormValues();
        }
        if (this.pagetitle === 'Update Schema') {
            this.schemsForm.markAsDirty();
            this.schemsForm.markAllAsTouched();
        }
        this.ngxUiLoaderService.stop();
    }

    // ngAfterViewInit() {}

    setFormValues() {
        // Example data source (you can replace this with your actual data source)
        if (this.jsonObject[0]?.type == 'section') {
            for (const sectionName in this.schemsForm.controls) {
                if (this.schemsForm.controls.hasOwnProperty(sectionName)) {
                    let sectionData: any = this.schemsForm.controls[sectionName];
                    for (const groupObject of sectionData.controls) {
                        for (const groupName in groupObject.controls) {
                            if (groupObject.controls.hasOwnProperty(groupName)) {
                                const groupData = groupObject.controls[groupName];
                                for (const controlName in groupData.controls) {
                                    if (groupData.controls.hasOwnProperty(controlName)) {
                                        if (controlName == 'images' && this.JsonDataContent?.images) {
                                            let ImageUrlList = this.JsonDataContent?.images.split(',');
                                            this.LoadImages(ImageUrlList);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    dataURItoBlob(dataURI) {
        const byteString = window.atob(dataURI);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const int8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([int8Array], { type: 'image/png' });
        return blob;
    }

    LoadImages(ImageUrl: any) {
        this.documentApiService.getUploadedImage(ImageUrl, localStorage.getItem('currentInstanceId')).subscribe(
            (res: any) => {
                if (res.success) {
                    if (res.response) {
                        let ImageUrlList: ImageDatas[];
                        ImageUrlList = res.response;
                        ImageUrlList.forEach((element) => {
                            let blobImage = this.createBlobUrl(element.content);
                            const imageBlob = this.dataURItoBlob(element.content);
                            const imageFile = new File([imageBlob], element.path.split('/').pop(), { type: 'image/png' });
                            this.images.push({
                                file: imageFile,
                                newurl: blobImage,
                                url: blobImage,
                            });
                        });
                        this.cd.detectChanges();
                    } else {
                        // this.customToastService.errorToast(res.message, "Error");
                    }
                }
            },
            (error) => {}
        );
    }

    initFormControls() {
        this.jsonObjectCopy.forEach((sec, i) => {
            if (sec.type.toLowerCase() == `section`) {
                this.isSaveEnable = true;
                this.schemsForm.addControl(`${sec.key}`, new UntypedFormArray([]));
                let Form = this.schemsForm.get(`${sec.key}`) as UntypedFormArray;

                sec.groups.forEach((field, pos) => {
                    let group = new UntypedFormGroup({});
                    // file deepcode ignore MissingArgument: <please specify a reason of ignoring this>
                    group.addControl(`${field.key}`, this.addControls(field, sec.key, pos));
                    Form.push(group);
                });
            } else if (sec.type.toLowerCase() == `tab`) {
                this.schemsForm.addControl(`${sec.key}`, new UntypedFormArray([])); //Array of tab forms
                let Form = this.schemsForm.get(`${sec.key}`) as UntypedFormArray; // Form array for particular tab

                sec.sections.forEach((section, pos) => {
                    let sectionForm = new UntypedFormArray([]); // Formarray for each section
                    section.groups.forEach((groups, j) => {
                        let group = new UntypedFormGroup({}); // Form group for fields inside section
                        group.addControl(`${groups.key}`, this.addControls(groups, groups.key, pos, j, sec.key));
                        sectionForm.push(group);
                    });
                    Form.push(sectionForm);
                });
            }
        });
        this.ngxUiLoaderService.stop();
    }

    selectionChange($event) {
        this.checkListSet.set($event.options[0]._value, !this.checkListSet.get($event.options[0]._value));
        if (!Array.from(this.checkListSet.values()).some((value) => value === true)) {
            this.customToastService.errorToast('Please select atleast one checkbox!!', 'Error');
        }
    }

    checkControl(controlname, secName, groupName, index, tab?: string, j?: number, k?: number) {
        if (this.jsonObjectCopy[0].type == 'section') {
            let sectionForm = this.schemsForm.get(secName) as UntypedFormArray;

            // if (controlname == 'startdate') {
            //     this.startdate = sectionForm.controls[index].get(groupName).get(`${controlname}`).value;
            // }
            // if (controlname == 'enddate') {
            //     this.enddate = sectionForm.controls[index].get(groupName).get(`${controlname}`).value;
            // }
            return sectionForm.controls[index].get(groupName).get(`${controlname}`) as FormControl;
        } else if (this.jsonObject[0].type == 'tab') {
            let tabForm = this.schemsForm.get(tab) as UntypedFormArray;
            let sectionForm = tabForm.controls[j] as UntypedFormArray;
            return sectionForm.controls[k].get(groupName).get(`${controlname}`) as FormControl;
        }
    }

    submitItem() {
        if (
            this.PageType == PageType.PlantManagerCreate ||
            this.PageType == PageType.PlantManagerEdit ||
            this.PageType == PageType.PlantManagerEditWithLatestSchema ||
            this.PageType == PageType.PlantManagerCopy
        ) {
            this.PlantManagerSaveObj.schemsForm = this.schemsForm;
            this.PlantManagerSaveObj.images = this.images;
            this.PlantManagerSaveObj.TaggedItemData = this.TaggedItemData;
            this.PlantManagerSaveObj.GroupType = this.jsonObject[0].type;
            this.PlantManagerSaveObj.selectedConnectorChild = this.selectedConnectorChild;
            this.PlantManagerSaveObj.PageType = this.PageType;
            this.PlantManagerSaveObj.lineNumberFormatId = this.lineNumberFormatId;
            this.PlantManagerSaveObj.pipeSpecVersionId = this.pipeSpecVersionId;

            if (this.PageType == PageType.PlantManagerEditWithLatestSchema)
                this.PlantManagerSaveObj.schemaVersionId = this.TaggedItemData.latestSchemaVersionId;
            else if (this.PageType == PageType.PlantManagerCreate) this.PlantManagerSaveObj.schemaVersionId = this.selectedConnectorChild.schemaVersionId;
            else
                this.PlantManagerSaveObj.schemaVersionId = this.TaggedItemData?.schemaVersionId
                    ? this.TaggedItemData.schemaVersionId
                    : this.TaggedItemData.schemaVersion.schemaVersionId;
            // this.plantmanagerService.saveTaggedItems.next(this.PlantManagerSaveObj);
            if (!this.PlantManagerSaveObj.CalculationResult) {
                let calcString = { type: this.calcType };
                this.PlantManagerSaveObj.CalculationResult = JSON.stringify(calcString);
            }
            this.idmsSharedService.SubmitTaggedItem(this.PlantManagerSaveObj);

            // this.cd.detectChanges();
        }

        if (
            this.PageType == PageType.ProjectManagerCreate ||
            this.PageType == PageType.ProjectManagerEdit ||
            this.PageType == PageType.ActivityPackAdd ||
            this.PageType == PageType.ActivityPackEdit ||
            this.PageType == PageType.ProjectMangerCopy ||
            this.PageType == PageType.WorkpackClone ||
            this.PageType == PageType.workpackCopy ||
            this.PageType == PageType.AddActivityTaggedItem ||
            this.PageType == PageType.EditActivityTaggedItem ||
            this.PageType == PageType.ProjectManagerEditWithLatestSchema ||
            this.PageType == PageType.ActivityPackEditWithLatestSchema ||
            this.PageType == PageType.ActivityTaggedItemEditWithLatestSchema
        ) {
            this.PlantManagerSaveObj.schemsForm = this.schemsForm;
            this.selectedImage ? (this.PlantManagerSaveObj.images = [this.selectedImage]) : '';
            this.PlantManagerSaveObj.GroupType = this.jsonObject[0].type;
            this.PlantManagerSaveObj.PageType = this.PageType;
            this.mode == 'pop-up' ? this.ngbActiveModal.close(this.PlantManagerSaveObj) : this.saveProjectmanager.emit(this.PlantManagerSaveObj);
        }
        if (
            (this.PageType as PageType) === PageType.AddLeakItem ||
            (this.PageType as PageType) === PageType.EditLeakItem ||
            (this.PageType as PageType) === PageType.ExceptionEditWithLatestSchema ||
            (this.PageType as PageType) === PageType.LeakEditWithLatestSchema ||
            (this.PageType as PageType) === PageType.AddExceptionItem ||
            (this.PageType as PageType) === PageType.EditExceptionItem
        ) {
            // if (this.startdate && this.enddate && this.compareDates(this.startdate, this.enddate)) {
            //     this.customToastService.errorToast('Start Date should be less than end date', 'Error');
            // } else {
            let FormData = {
                schemsForm: this.schemsForm,
                Tab: this.Tab,
                PlantManagerSaveObj: this.PlantManagerSaveObj,
            };

            // this.plantmanagerService.LeakOrExceptionFormGroups.next(FormData);
            this.idmsSharedService.updateFormException(FormData);
            this.PlantManagerSaveObj.Tab = this.Tab;
            this.PlantManagerSaveObj.schemsForm = this.schemsForm;
            this.PlantManagerSaveObj.images = this.images;
            this.PlantManagerSaveObj.TaggedItemData = this.TaggedItemData;
            this.PlantManagerSaveObj.GroupType = this.jsonObject[0].type;
            this.PlantManagerSaveObj.PageType = this.PageType;
            this.PlantManagerSaveObj.schemaVersionId =
                this.Tab == 1 ? this.AdditionalInfo.DetailsSchemaVersionId : this.AdditionalInfo.LeakOrExceptionschemaVersionId;
            this.PlantManagerSaveObj.IsSave = this.Tab == 2 ? true : false;
            this.PlantManagerSaveObj.AdditionalInfo = this.AdditionalInfo;
            this.PlantManagerSaveObj.GroupType = this.jsonObject[0].type;

            // this.plantmanagerService.saveLeakOrException.next(this.PlantManagerSaveObj);
            this.idmsSharedService.SubmitLeakAndException(this.PlantManagerSaveObj);
            // }
        }
    }

    getValuesByKey(keySerch) {
        for (const key in this.schemsForm.value) {
            if (key == keySerch) {
                return this.schemsForm.value[key];
            }
        }
    }

    MakingNewObjectforControls() {
        this.jsonObjectCopy = this.jsonObject.map((x, i) => {
            if (x.type.toLowerCase() === 'section') {
                return {
                    key: x.key.toLowerCase(),
                    type: x.type.toLowerCase(),
                    alias: x?.alias || x?.key,
                    groups: x.groups.map((y, i) => {
                        return {
                            key: y.key.toLowerCase(),
                            type: y.type.toLowerCase(),
                            alias: y?.alias || y.key.toLowerCase(),
                            fields: y.fields.map((f) => this.newJsonObject(f)),
                        };
                    }),
                };
            } else if (x.type.toLowerCase() == 'tab') {
                return {
                    key: x.key.toLowerCase(),
                    alias: x?.alias || x?.key,
                    type: x.type.toLowerCase(),
                    sections: x.sections.map((y, i) => {
                        return {
                            key: y.key.toLowerCase(),
                            alias: y?.alias || y?.key,
                            type: y.type.toLowerCase(),
                            groups: y.groups.map((f) => {
                                return {
                                    key: f.key.toLowerCase(),
                                    type: x.type.toLowerCase(),
                                    alias: f?.alias || f?.key,
                                    fields: f.fields.map((y) => this.newJsonObject(y)),
                                };
                            }),
                        };
                    }),
                };
            }
            // else {
            //     {
            //       return({   key:x.key,
            //         alias:x.alias,
            //         fields: x.fields.map(f=>this.newJsonObject(f))
            //     })

            //     }
            //   }
        });
    }

    newJsonObject(field) {
        const copyField: ResultObj = {
            key: field.key.toLowerCase(),
            type: field.type.toLowerCase(),
            alias: field.alias,
            Placeholder: '',
            ismask: false,
            mask: '',
            maskValue: '',
            DecimalPlaces: '',
            excludedunits: '',
            UnitType: '',
            DisplayUnit: '',
            validators: field.validators,
            selections: '',
            Default: field.default,
            imageoption: field.imageoption,
            scopekey: field.scopekey,
            apikey: field.apikey,
            parameters: field.parameters,
            userList: [],
            userListSearch: [],
            isnameprimary: field?.isnameprimary,
            datetype: field.datetype,
        };
        if (field.imageoption) {
            copyField.imageoption = field.imageoption;
        }
        if (field.selections) {
            copyField.selections = field.selections;
        }
        if (field.Default) {
            copyField.Default = field.Default;
        }

        (field.parameters || []).forEach((param) => {
            switch (param.key) {
                case 'Placeholder':
                case 'placeholder':
                    copyField.Placeholder = param.value ? param.value : param.Value;
                    break;

                case 'UserInputMask':
                    copyField.ismask = true;
                    copyField.mask = param.mask;
                    if (param.mask == 'AA9[9] 9AA') {
                        copyField.maskValue = 'SS09 0SS';
                    } else if (param.mask == '(999) 999 9999') {
                        copyField.maskValue = '(000) 000 0000';
                    } else if (param.mask == '99:99') {
                        copyField.maskValue = '00 : 00';
                    }
                    break;
            }
            if (param.unittype) {
                // copyField.DisplayUnit =
                const unitType = this.UnitTypeArray.find((x) => x.key.toLowerCase() === param.unittype.toLowerCase());

                if (unitType) {
                    copyField.DisplayUnit = unitType.units.map((y) => {
                        const newobj = {
                            key: y,
                            decimalPoint: null,
                        };

                        if (param.decimalplaces) {
                            param.decimalplaces.forEach((decimal) => {
                                const pointArray = decimal.split('-');
                                if (pointArray[0] === y) {
                                    newobj.decimalPoint = pointArray[1];
                                }
                            });
                        }

                        return newobj;
                    });

                    if (param.excludedunits) {
                        copyField.excludedunits = param.excludedunits;
                        copyField.DisplayUnit = copyField.DisplayUnit.filter((unit) => !copyField.excludedunits.includes(unit.key));
                    }
                }
            }
        });
        if (
            this.PageType == PageType.PlantManagerCreate ||
            this.PageType == PageType.PlantManagerEdit ||
            this.PageType == PageType.ProjectManagerCreate ||
            this.PageType == PageType.ProjectManagerEdit ||
            this.PageType == PageType.PlantManagerEditWithLatestSchema ||
            this.PageType == PageType.PlantManagerCopy ||
            this.PageType == PageType.ActivityPackAdd ||
            this.PageType == PageType.ActivityPackEdit ||
            this.PageType == PageType.ProjectMangerCopy ||
            this.PageType == PageType.WorkpackClone ||
            this.PageType == PageType.workpackCopy ||
            this.PageType == PageType.AddActivityTaggedItem ||
            this.PageType == PageType.EditActivityTaggedItem ||
            (this.PageType as PageType) === PageType.AddLeakItem ||
            (this.PageType as PageType) === PageType.EditLeakItem ||
            (this.PageType as PageType) === PageType.AddExceptionItem ||
            (this.PageType as PageType) === PageType.EditExceptionItem ||
            (this.PageType as PageType) === PageType.ExceptionEditWithLatestSchema ||
            (this.PageType as PageType) === PageType.LeakEditWithLatestSchema ||
            (this.PageType as PageType) === PageType.ProjectManagerEditWithLatestSchema ||
            (this.PageType as PageType) === PageType.ActivityPackEditWithLatestSchema
        ) {
            if (field?.isnameprimary == 'true') {
                if (
                    ((this.PageType as PageType) === PageType.PlantManagerCopy && this.JsonDataContent) ||
                    ((this.PageType as PageType) === PageType.ProjectMangerCopy && this.JsonDataContent) ||
                    ((this.PageType as PageType) === PageType.WorkpackClone && this.JsonDataContent) ||
                    ((this.PageType as PageType) === PageType.workpackCopy && this.JsonDataContent) ||
                    ((this.PageType as PageType) === PageType.AddActivityTaggedItem && this.JsonDataContent) ||
                    ((this.PageType as PageType) === PageType.EditActivityTaggedItem && this.JsonDataContent)
                ) {
                    if (this.TaggedItemData?.taggedItemType != 'Line') this.JsonDataContent[field?.key] = '';
                }

                //if (
                //    ((this.PageType as PageType) === PageType.PlantManagerCopy && this.JsonDataContent) ||
                //    ((this.PageType as PageType) === PageType.ProjectMangerCopy && this.JsonDataContent) ||
                //    ((this.PageType as PageType) === PageType.WorkpackClone && this.JsonDataContent) ||
                //    ((this.PageType as PageType) === PageType.workpackCopy && this.JsonDataContent)
                //) {
                //    if (this.TaggedItemData?.taggedItemType != 'Line') this.JsonDataContent[field?.key] = '';
                //}

                this.PlantManagerSaveObj.NamePrimaryKey = field.key;
            }
            if (field?.datetype == 'startdate' || field?.datetype == 'enddate' || field.type == 'date') {
                this.PlantManagerSaveObj.dateTypeKey.push(field?.key);
                if (
                    ((this.PageType as PageType) === PageType.ProjectMangerCopy && this.JsonDataContent) ||
                    ((this.PageType as PageType) === PageType.WorkpackClone && this.JsonDataContent) ||
                    ((this.PageType as PageType) === PageType.workpackCopy && this.JsonDataContent)
                ) {
                    this.JsonDataContent[field?.key] = '';
                }
            }
            if (field?.isnamesecondary == 'true') {
                this.PlantManagerSaveObj.NameSecondaryKey = field.key;
            }
            if (field?.type == 'imageupload') {
                this.PlantManagerSaveObj.imageKey = field.key;
            }
        }

        if (
            this.PageType == PageType.ProjectManagerCreate ||
            this.PageType == PageType.ProjectManagerEdit ||
            this.PageType == PageType.ActivityPackAdd ||
            this.PageType == PageType.ActivityPackEdit ||
            this.PageType == PageType.ProjectManagerEditWithLatestSchema ||
            this.PageType == PageType.ActivityPackEditWithLatestSchema ||
            this.PageType == PageType.ProjectMangerCopy
        ) {
            if (field?.type == 'imageupload') {
                field.imageoption == 'logo' && this.JsonDataContent && this.JsonDataContent[field?.key]
                    ? (this.imageUrl = this.JsonDataContent[field?.key])
                    : '';
                this.JsonDataContent ? (this.PlantManagerSaveObj.ImageUrl = this.JsonDataContent[field?.key]) : (this.PlantManagerSaveObj.ImageUrl = '');
                this.PlantManagerSaveObj.imageKey = field.key;
            }
        }
        if (
            (this.PageType as PageType) === PageType.AddLeakItem ||
            (this.PageType as PageType) === PageType.EditLeakItem ||
            (this.PageType as PageType) === PageType.AddExceptionItem ||
            (this.PageType as PageType) === PageType.EditExceptionItem ||
            (this.PageType as PageType) === PageType.ExceptionEditWithLatestSchema ||
            (this.PageType as PageType) === PageType.LeakEditWithLatestSchema
        ) {
            if (field?.type == 'imageupload') {
                field.imageoption == 'logo' && this.JsonDataContent?.images ? (this.imageUrl = this.JsonDataContent[field?.key]) : (this.imageUrl = null);
                this.PlantManagerSaveObj.imageKey = field.key;
            }
        }

        return copyField;
    }

    addControls(resp, sectionFormName: string, index: number, j?: number, tabName?: string) {
        // let group = this.schemsForm.addControl(`${resp.key}`,new FormGroup({}));
        let groupForm = new UntypedFormGroup({});
        resp.fields.map(async (res, i) => {
            if (res.type.toLowerCase() == 'linenumber') {
                this.getLineNumberFormet(res.key, resp.key, sectionFormName, index, j, tabName);
            } else if (res.type.toLowerCase() == 'dbselect') {
                if (res.apikey) {
                    let instanceId = localStorage.getItem('currentInstanceId');

                    // this.ngxUiLoaderService.start();
                    this.idmApiService.getDbSelectsValuesByInstanceId(instanceId, res.apikey).subscribe(
                        (dbSelectResp) => {
                            if (dbSelectResp.success) {
                                // this.ngxUiLoaderService.stop();
                                // let secForm = this.schemsForm.get(sectionFormName) as UntypedFormArray;
                                let dbselectData;
                                if (res.apikey == 'CompetencyModule') {
                                    dbselectData = [
                                        { databaseSelectValueId: 'L1', name: 'L1 BJI - Basic Joint Integrity', active: true },
                                        { databaseSelectValueId: 'L2', name: 'L2 ADV - Advanced Bolting', active: true },
                                        { databaseSelectValueId: 'L3', name: 'L3 SUP - Supervisor Competency', active: true },
                                    ];
                                    let Group: UntypedFormGroup = this.getFormGroup(sectionFormName, resp.key, index, tabName, j);

                                    res.selections = dbselectData;
                                    let validatorsToAdd = this.applyValidators(res);
                                    Group.addControl(
                                        res.key,
                                        this.formBuilder.control(this.JsonDataContent ? this.JsonDataContent[res.key] : '', validatorsToAdd)
                                    );
                                    this.cd.detectChanges();
                                } else if (res.apikey == 'AssessmentCategory') {
                                    dbselectData = [
                                        { databaseSelectValueId: 'CAT1', name: '1 - Training, Logbook & Assessment', active: true },
                                        { databaseSelectValueId: 'CAT2', name: '2 - Assessment Only', active: true },
                                        { databaseSelectValueId: 'CAT3', name: '3 - Logbook Verification', active: true },
                                    ];
                                    let Group: UntypedFormGroup = this.getFormGroup(sectionFormName, resp.key, index, tabName, j);

                                    res.selections = dbselectData;
                                    let validatorsToAdd = this.applyValidators(res);
                                    Group.addControl(
                                        res.key,
                                        this.formBuilder.control(this.JsonDataContent ? this.JsonDataContent[res.key] : '', validatorsToAdd)
                                    );
                                    this.cd.detectChanges();
                                } else if (res.apikey == 'Role') {
                                    dbselectData = [
                                        { databaseSelectValueId: 'TECH', name: 'Technician', active: true },
                                        { databaseSelectValueId: 'ENG', name: 'Engineer', active: true },
                                        { databaseSelectValueId: 'SUP', name: 'Supervisor', active: true },
                                        { databaseSelectValueId: 'MGR', name: 'Manager', active: true },
                                    ];
                                    let Group: UntypedFormGroup = this.getFormGroup(sectionFormName, resp.key, index, tabName, j);

                                    res.selections = dbselectData;
                                    let validatorsToAdd = this.applyValidators(res);
                                    Group.addControl(
                                        res.key,
                                        this.formBuilder.control(this.JsonDataContent ? this.JsonDataContent[res.key] : '', validatorsToAdd)
                                    );
                                    this.cd.detectChanges();
                                } else {
                                    let Group: UntypedFormGroup = this.getFormGroup(sectionFormName, resp.key, index, tabName, j);

                                    res.selections = dbSelectResp.response;
                                    let validatorsToAdd = this.applyValidators(res);
                                    Group.addControl(
                                        res.key,
                                        this.formBuilder.control(this.JsonDataContent ? this.JsonDataContent[res.key] : '', validatorsToAdd)
                                    );

                                    if (res?.Default) {
                                        let value = res.selections.find((m) => m.name == res.Default);
                                        if (value?.databaseSelectValueId) {
                                            groupForm.get(`${res.key}`).setValue(value?.databaseSelectValueId);
                                        }
                                    }
                                    this.cd.detectChanges();
                                }
                            } else {
                                this.user_utlity.errorModelPopup(dbSelectResp.message);
                                // this.ngxUiLoaderService.stop();
                            }
                        },
                        (err) => {
                            this.user_utlity.errorModelPopup(err.err);
                            this.ngxUiLoaderService.stop();
                        }
                    );
                } else {
                    this.user_utlity.errorModelPopup('Invalid Json Object!');
                }
            } else if (res.type.toLowerCase() == 'measurementunit') {
                let newGroup = new FormGroup({
                    value: new FormControl(this.JsonDataContent ? this.JsonDataContent[res.key].split(' ')[0] : '', [Validators.required]),
                    unit: new FormControl(this.JsonDataContent ? this.JsonDataContent[res.key].split(' ')[1] : '', [Validators.required]),
                });

                groupForm.addControl(`${res.key}`, newGroup);
            } else if (res.type.toLowerCase() == 'circularslider') {
                if (this.JsonDataContent) {
                    groupForm.addControl(`${res.key}`, this.formBuilder.control(this.JsonDataContent[res.key] ? this.JsonDataContent[res.key] : ''));
                    if (this.JsonDataContent[res.key]) this.speedValue = this.JsonDataContent[res.key];
                } else groupForm.addControl(`${res.key}`, this.formBuilder.control(''));
            } else if (res.type.toLowerCase() == 'userselect') {
                if (res.scopekey === 'OrganizationUsers') {
                    let Org = localStorage.getItem('selectedOrgId');
                    let apiResult = await this.managementApiService.getUsersForOrganization(Org).toPromise();
                    if (apiResult.success) {
                        for (let i = 0; i < apiResult.response.length; i++) {
                            let userObject = {
                                //
                                userId: apiResult.response[i].userId,
                                firstName: apiResult.response[i].profileContact.firstName,
                                lastName: apiResult.response[i].profileContact.lastName,
                                email: apiResult.response[i].profileContact.email,
                                fullName: apiResult.response[i].profileContact.fullName,
                            };
                            res.userList.push(userObject);
                        }
                        res.userListCopy = [...res.userList];
                    }
                } else if (res.scopekey === 'InstanceUsers') {
                    let instanceId = localStorage.getItem('currentInstanceId');
                    let apiResponse = await this.managementApiService.getUserInstances(instanceId).toPromise();
                    if (apiResponse.success) {
                        for (let i = 0; i < apiResponse.response.users.length; i++) {
                            let userObject = {
                                userId: apiResponse.response.users[i].user.userId,
                                firstName: apiResponse.response.users[i].user.profileContact.firstName,
                                lastName: apiResponse.response.users[i].user.profileContact.lastName,
                                email: apiResponse.response.users[i].user.profileContact.email,
                                fullName: apiResponse.response.users[i].user.profileContact.fullName,
                            };
                            res.userList.push(userObject);
                        }
                        res.userListCopy = [...res.userList];
                    }
                }
                let selectedUser;
                if (this.JsonDataContent && res.userListCopy?.length) {
                    selectedUser = res.userListCopy?.find((x) => x.userId == this.JsonDataContent[res?.key]);
                }
                let validatorsToAdd = this.applyValidators(res);
                groupForm.addControl(
                    `${res.key}`,
                    this.formBuilder.control(selectedUser ? selectedUser : '', [userSelectionValidator(res.userList), ...validatorsToAdd])
                );
                // this.PlantManagerSaveObj.userList = this.userListCopy;
                this.PlantManagerSaveObj.userSelectKey.push(res.key);
            } else if (res.type.toLowerCase() == controlTypes.tighteningdetails) {
                try {
                    this.ngxUiLoaderService.start();
                    this.isLoading = true;
                    let dataContent;

                    if (this.TaggedItemData?.taggedItemId) {
                        let resp = await this.idmApiService.GetTaggedItemDataById(this.TaggedItemData?.taggedItemId).toPromise();
                        dataContent = JSON.parse(resp.response.dataContent);
                    } else if (this.DataContent) {
                        dataContent = JSON.parse(this.DataContent);
                    }

                    // let resp = await this.idmApiService.GetTaggedItemDataById(this.TaggedItemData.taggedItemId).toPromise();
                    // let dataContent = JSON.parse(resp.response.dataContent);

                    if (dataContent?.jointcalculation) {
                        this.isJointCalculationAvailable = true;
                        let calcResult: CalculationResult = JSON.parse(dataContent?.jointcalculation.replace(/\$Inch\$/g, '"'));
                        this.calcResult = calcResult;

                        if (this.calcResult?.output?.general?.warnings && this.calcResult?.output?.general?.warnings.length > 0) {
                            this.warningMesaages = this.calcResult?.output?.general?.warnings;
                        }

                        let Data;
                        if (this.DataContent) {
                            Data = JSON.parse(this.DataContent.replace("')", ''));
                        }
                        if (Data) {
                            if (Data[res?.key]) {
                                let TighteningDetails: tighteningDetails = this.JsonDataContent[res.key];

                                this.general = this.calcResult?.output?.general;

                                const torqueList = [
                                    {
                                        key: this.general?.torquePercentageText1 ? this.general?.torquePercentageText1 : '',
                                        value: this.general?.torquePercentage1 ? this.general.torquePercentage1 : '',
                                    },
                                    {
                                        key: this.general?.torquePercentageText2 ? this.general?.torquePercentageText2 : '',
                                        value: this.general?.torquePercentage2 ? this.general.torquePercentage2 : '',
                                    },
                                    {
                                        key: this.general?.torquePercentageText3 ? this.general?.torquePercentageText3 : '',
                                        value: this.general?.torquePercentage3 ? this.general.torquePercentage3 : '',
                                    },
                                    {
                                        key: this.general?.torquePercentageText4 ? this.general?.torquePercentageText4 : '',
                                        value: this.general?.torquePercentage4 ? this.general.torquePercentage4 : '',
                                    },
                                ];

                                this.selectedTorqueUnit = TighteningDetails.torqueapplied.unit;
                                this.selectedTensionUnit = TighteningDetails.pressureapplied.unit;
                                this.selectedToolId = TighteningDetails.toolid;
                                this.selectedTool = this.calcResult?.output?.tools?.find((x) => x.id == this.selectedToolId);
                                this.tighteningMethod = TighteningDetails.tighteningmethod == 'Torque' ? 0 : 1;
                                this.ToolingValue = TighteningDetails.toolingvalueas;
                                this.resBoltStress = TighteningDetails.boltstress;
                                // this.TorquePassValues = TighteningDetails.torqueapplied.passvalues;
                                //  this.TorquePassValues = torqueList;
                                // this.PumpPressurepassValues = TighteningDetails.pressureapplied.passvalues;
                                // await this.LoadPassValues();
                                if (this?.JsonDataContent?.tighteningdetails?.torqueapplied?.passvalues && !this.ToolingValue) {
                                    this.TorquePassValues = this?.JsonDataContent?.tighteningdetails?.torqueapplied?.passvalues;
                                } else {
                                    await this.LoadPassValues();
                                }

                                if (this?.JsonDataContent?.tighteningdetails?.pressureapplied?.passvalues && !this.ToolingValue) {
                                    this.PumpPressurepassValues = this?.JsonDataContent?.tighteningdetails?.pressureapplied?.passvalues;
                                } else {
                                    await this.LoadPassValues();
                                }
                            }
                        } else {
                            if (dataContent?.jointcalculation) {
                                this.selectedTool = this.calcResult?.output?.tools?.find((x) => x.isSelected == true);
                                this.selectedToolId = this.selectedTool?.id;

                                this.selectedTorqueUnit = 'Nm';
                                this.selectedTensionUnit = 'Bar';
                                this.tighteningMethod = this.calcResult?.input?.others?.tighteningMethod;

                                this.resBoltStress =
                                    this.calcResult?.output?.bolt?.residualBoltStress.metric.stringValue.replace(/\s+/g, ' ').trim() +
                                    '(' +
                                    this.calcResult?.output?.bolt?.residualBoltStress.imperial.stringValue.replace(/\s+/g, ' ').trim() +
                                    ')';
                                // await this.LoadPassValues();
                                if (this?.JsonDataContent?.tighteningdetails?.torqueapplied?.passvalues && !this.ToolingValue) {
                                    this.TorquePassValues = this?.JsonDataContent?.tighteningdetails?.torqueapplied?.passvalues;
                                } else {
                                    await this.LoadPassValues();
                                }

                                if (this?.JsonDataContent?.tighteningdetails?.pressureapplied?.passvalues && !this.ToolingValue) {
                                    this.PumpPressurepassValues = this?.JsonDataContent?.tighteningdetails?.pressureapplied?.passvalues;
                                } else {
                                    await this.LoadPassValues();
                                }
                            }
                        }
                        this.iceApiService.getwarningsbyType(72).subscribe((resp) => {
                            if (resp.success) {
                                this.ToolingWarning = resp.response.message;
                            }
                        });
                        let tighteningFormGroup: FormGroup = this.createForm();

                        groupForm.addControl(`${res.key}`, tighteningFormGroup);
                        this.ngxUiLoaderService.stop();
                        this.isLoading = false;
                    } else {
                        this.isLoading = false;
                        this.isJointCalculationAvailable = false;
                        groupForm.addControl(`${res.key}`, this.formBuilder.control({}));
                    }
                } catch (e) {
                    this.ngxUiLoaderService.stop();
                    this.isLoading = false;
                }
            } else if (res.type.toLowerCase() == controlTypes.alignment) {
                let alimentGroup = new FormGroup({
                    studboltsreplaced: new FormControl(
                        this.JsonDataContent && this.JsonDataContent[res.key]?.studboltsreplaced ? this.JsonDataContent[res.key]?.studboltsreplaced : false
                    ),
                    gasketreplaced: new FormControl(
                        this.JsonDataContent && this.JsonDataContent[res.key]?.gasketreplaced ? this.JsonDataContent[res.key]?.gasketreplaced : false
                    ),
                    flangefacerepairrequired: new FormControl(
                        this.JsonDataContent && this.JsonDataContent[res.key]?.flangefacerepairrequired
                            ? this.JsonDataContent[res.key]?.flangefacerepairrequired
                            : false
                    ),
                    paintundernutremoved: new FormControl(
                        this.JsonDataContent && this.JsonDataContent[res.key]?.paintundernutremoved
                            ? this.JsonDataContent[res.key]?.paintundernutremoved
                            : false
                    ),
                    correctstud: new FormControl(
                        this.JsonDataContent && this.JsonDataContent[res.key]?.correctstud ? this.JsonDataContent[res.key]?.correctstud : false
                    ),
                    studscorrectlylubricated: new FormControl(
                        this.JsonDataContent && this.JsonDataContent[res.key]?.studscorrectlylubricated
                            ? this.JsonDataContent[res.key]?.studscorrectlylubricated
                            : false
                    ),
                    datalist: new FormArray([]),
                });
                let dataListArray = alimentGroup.get('datalist') as FormArray;
                let datalist;
                if (this.JsonDataContent) {
                    datalist = this.JsonDataContent[res?.key]?.datalist ? this.JsonDataContent[res?.key]?.datalist : this.AlignmentData.datalist;
                } else {
                    datalist = this.AlignmentData.datalist;
                }
                datalist.forEach((x, i) => {
                    let dataControls = new FormGroup({
                        name: new FormControl(x?.name),
                        zerodrg: new FormControl(x?.zerodrg),
                        ninetydrg: new FormControl(x?.ninetydrg),
                        oneeightydrg: new FormControl(x?.oneeightydrg),
                        twoseventydrg: new FormControl(x?.twoseventydrg),
                    });

                    // Push the dataControls FormGroup to the FormArray
                    dataListArray.push(dataControls);
                });

                groupForm.addControl(`${res.key}`, alimentGroup);
            } else if (
                res.type == 'jointcalculation' &&
                this.JsonDataContent?.jointcalculation &&
                this.JsonDataContent?.jointcalculation != 'null' &&
                this.JsonDataContent?.jointcalculation?.length > 20
            ) {
                let validatorsToAdd = this.applyValidators(res);
                this.showPrint = true;
                let Result =
                    typeof this.JsonDataContent['jointcalculation'] == 'string'
                        ? this.JsonDataContent['jointcalculation']
                        : JSON.stringify(this.JsonDataContent['jointcalculation']);
                Result = Result.replace(/\r/g, '\\r').replace(/\n/g, '\\n').replace(/\t/g, '\\t');
                let calcResult: CalculationResult = JSON.parse(Result.replace(/\$Inch\$/g, '"'));
                this.PlantManagerSaveObj.CalculationResult = Result;
                this.calcResult = calcResult;
                //To update  flange details tab
                this.globalEmittersService.calculationResult.next(calcResult);
                groupForm.addControl(`${res.key}`, this.formBuilder.control(calcResult ? String(calcResult?.type) : '', validatorsToAdd));
                this.calcType = calcResult ? parseInt(calcResult?.type) : -1;
                //To bind dat in stress-factors-output
                if (calcResult?.diagramInfo) {
                    this.globalEmittersService.diagramInfo.next(calcResult.diagramInfo);
                } else {
                    if (this.calcResult?.calculationSucceeded && (this.calcResult.type == '0' || this.calcResult.type == '2')) {
                        //Flange Type
                        let flangeTypeDiagramId = '';
                        let flangeFacingTypeDiagramId = '';
                        let flangeGasketDiagram = '';
                        let gesketTypeId = '';
                        let pipeSpecFlangeType = await this.iceApiService
                            .getFlangeTypes(
                                this.calcResult?.input?.recordId.standardId,
                                this.calcResult?.input?.recordId.pressureClassId,
                                this.calcResult?.input?.recordId.pipeSizeId
                            )
                            .pipe()
                            .toPromise();

                        if (pipeSpecFlangeType.success) {
                            if (pipeSpecFlangeType.response?.length > 0) {
                                flangeTypeDiagramId = pipeSpecFlangeType.response.find(
                                    (m) => m.flangeTypeId == this.calcResult?.input?.recordId.flangeTypeId
                                ).diagramId;
                            }
                        }
                        // Flange type end
                        let pipeSpecFlangeFacingType = await this.iceApiService
                            .getFlangeFacingTypes(this.calcResult?.input?.recordId.flangeTypeId, this.calcResult?.input?.recordId.pressureClassId, null)
                            .pipe()
                            .toPromise();
                        if (pipeSpecFlangeFacingType.success) {
                            if (pipeSpecFlangeFacingType.response?.length > 0) {
                                flangeFacingTypeDiagramId = pipeSpecFlangeFacingType.response.find(
                                    (m) => m.flangeFacingTypeId == this.calcResult?.input?.recordId.flangeFacingTypeId
                                ).diagramId;
                            }
                        }

                        // Flange facing type end
                        let pipeSpecGasket = await this.idmApiService
                            .getCalcgetGaskets(
                                this.calcResult?.input?.recordId.standardId,
                                this.calcResult?.input?.recordId.flangeFacingTypeId,
                                this.calcResult?.input?.recordId.pressureClassId,
                                this.calcResult?.input?.recordId.pipeSizeId,
                                this.calcResult.type == '0',
                                false,
                                false
                            )
                            .pipe()
                            .toPromise();
                        if (pipeSpecGasket.success) {
                            if (pipeSpecGasket.response?.length > 0) {
                                flangeGasketDiagram = pipeSpecGasket.response.find((m) => m.gasketId == this.calcResult?.input?.recordId.gasketId).diagramId;
                                gesketTypeId = pipeSpecGasket.response.find((m) => m.gasketId == this.calcResult?.input?.recordId.gasketId).gasketType
                                    .gasketTypeId;
                            }
                        }

                        let diagram = new DiagramDataModel();
                        diagram.isDiagramsAdded = true;
                        diagram.isEditable = false;
                        let diagramInfoFlange = new DiagramInfo();
                        diagramInfoFlange.diagramId = flangeTypeDiagramId;
                        diagramInfoFlange.diagramType = 'Flange';
                        diagramInfoFlange.pressureClassId = this.calcResult?.input?.recordId.pressureClassId;
                        diagramInfoFlange.flangeTypeId = this.calcResult?.input?.recordId.flangeTypeId;
                        diagramInfoFlange.pipesizeId = this.calcResult?.input?.recordId.pipeSizeId;
                        diagramInfoFlange.noOfBolts = 0;
                        diagram.flange = diagramInfoFlange;

                        let diagramInfoFlangeFacing = new DiagramInfo();
                        diagramInfoFlangeFacing.diagramId = flangeTypeDiagramId;
                        diagramInfoFlangeFacing.diagramType = 'Flange Facing';
                        diagramInfoFlangeFacing.pressureClassId = this.calcResult?.input?.recordId.pressureClassId;
                        diagramInfoFlangeFacing.flangeTypeId = this.calcResult?.input?.recordId.flangeTypeId;
                        diagramInfoFlangeFacing.pipesizeId = this.calcResult?.input?.recordId.pipeSizeId;
                        diagramInfoFlangeFacing.flangeFacingTypeId = this.calcResult?.input?.recordId.flangeFacingTypeId;
                        diagramInfoFlangeFacing.noOfBolts = 0;
                        diagram.flangeFacing = diagramInfoFlangeFacing;

                        let diagramInfoGasket = new DiagramInfo();
                        diagramInfoGasket.diagramId = flangeGasketDiagram;
                        diagramInfoGasket.diagramType = 'Gasket';
                        diagramInfoGasket.pressureClassId = this.calcResult?.input?.recordId.pressureClassId;
                        diagramInfoGasket.flangeTypeId = this.calcResult?.input?.recordId.flangeTypeId;
                        diagramInfoGasket.pipesizeId = this.calcResult?.input?.recordId.pipeSizeId;
                        diagramInfoGasket.flangeFacingTypeId = this.calcResult?.input?.recordId.flangeFacingTypeId;
                        diagramInfoGasket.gasketTypeId = gesketTypeId;
                        diagramInfoGasket.noOfBolts = 0;
                        diagram.gasket = diagramInfoGasket;
                        diagram.torqueSequenceName = this.calcResult.output.bolt.boltQuantity + 'Hole';
                        this.globalEmittersService.diagramInfo.next(diagram);
                    } else this.globalEmittersService.diagramInfo.next(null);
                }

                // this.calcType = -1;
            } else if (res.type == 'jointidinput') {
                // if (
                //     this.selectedConnectorChild?.taggedItemType == 'Joint' ||
                //     this.plantmanagerService?.activeTaggedItem?.taggedItemType == 'Joint' ||
                //     (this.PageType == PageType.PlantManagerCopy && this.TaggedItemData.taggedItemType == 'Joint')
                // ) {
                await this.getJointIDSettingArea();

                let validatorsToAdd = this.applyValidators(res);
                const controlValue = this.JsonDataContent?.[res.key] ? String(this.JsonDataContent[res.key]) : '';

                const isPlantCreateOrCopy = this.PageType === PageType.PlantManagerCreate || this.PageType === PageType.PlantManagerCopy;

                const isAutoAbbreviation = this.jointIdSetting?.userPreference === 'Auto-Generate on Ancestory';

                if (isPlantCreateOrCopy && isAutoAbbreviation) {
                    const activeItem = this.plantmanagerService.isOpenChild
                        ? this.plantmanagerService.activeTaggedItemForAddChild
                        : this.plantmanagerService.activeTaggedItem;

                    const namePrimary = activeItem?.namePrimary ?? '';

                    groupForm.addControl(res.key, this.formBuilder.control(`${namePrimary}${this.jointIdPrefixValue.userPreference}`, validatorsToAdd));

                    this.plantmanagerService.isOpenChild = false;

                    // mark only once because condition already checked
                    this.schemsForm.markAsDirty();
                    this.schemsForm.markAllAsTouched();
                } else {
                    groupForm.addControl(res.key, this.formBuilder.control(controlValue, validatorsToAdd));
                }

                // }
            } else {
                let validatorsToAdd = this.applyValidators(res);

                if (res.type.toLowerCase() == 'date') {
                    let date = this.JsonDataContent && this.JsonDataContent[res.key] ? this.idmsSharedService.julianToIso(this.JsonDataContent[res.key]) : '';

                    groupForm.addControl(`${res.key}`, this.formBuilder.control(date, validatorsToAdd));

                    if (res.datetype === 'startdate') {
                        this.startdate = groupForm.get(`${res.key}`) as FormControl;
                    } else if (res.datetype === 'enddate') {
                        this.enddate = groupForm.get(`${res.key}`) as FormControl;
                    }

                    // Apply the validator after both controls exist
                    if (this.startdate && this.enddate) {
                        groupForm.setValidators(this.compareDatesValidator(this.startdate, this.enddate));
                        groupForm.updateValueAndValidity(); // Ensure validation runs
                    }
                } else if (res.type.toLowerCase() == 'checkbox') {
                    groupForm.addControl(
                        `${res.key}`,
                        this.formBuilder.control(
                            this.JsonDataContent ? (this.JsonDataContent[res.key] ? String(this.JsonDataContent[res.key]) : false) : false,
                            checkboxValidator()
                        )
                    );
                    if (res?.Default && !this.JsonDataContent) {
                        groupForm.get(`${res.key}`).setValue(res.Default == 'true' ? true : false);
                    }
                } else if (res.type == 'checkboxlist') {
                    const value = this.JsonDataContent?.[res.key] ?? res.Default ?? [];

                    groupForm.addControl(res.key, this.formBuilder.control(Array.isArray(value) ? value : [], validatorsToAdd));
                } else if (res.type == 'radiobuttonlist') {
                    let defaultValue = '';
                    groupForm.addControl(`${res.key}`, this.formBuilder.control('', validatorsToAdd));
                    if (this.JsonDataContent && this.JsonDataContent[res.key]) {
                        // Value coming from saved data
                        defaultValue = this.JsonDataContent[res.key];
                    } else if (res.Default) {
                        // Default value from JSON
                        defaultValue = res.Default;
                    }

                    groupForm.get(`${res.key}`).setValue(defaultValue);
                } else if (res.type == 'select') {
                    groupForm.addControl(
                        `${res.key}`,
                        this.formBuilder.control(
                            this.JsonDataContent ? (this.JsonDataContent[res.key] ? String(this.JsonDataContent[res.key]) : '') : '',
                            validatorsToAdd
                        )
                    );
                    if (res?.Default && !this.JsonDataContent) {
                        groupForm.get(`${res.key}`).setValue(res?.Default);
                    }
                    // else if (this.JsonDataContent) {
                    //     groupForm.get(`${res.key}`).setValue(this.JsonDataContent[res.key]);
                    // }
                } else {
                    groupForm.addControl(
                        `${res.key}`,
                        this.formBuilder.control(
                            this.JsonDataContent ? (this.JsonDataContent[res.key] ? String(this.JsonDataContent[res.key]) : '') : '',
                            validatorsToAdd
                        )
                    );
                }

                // validatorsToAdd = [];
                // if (res?.Default && !this.JsonDataContent) {
                //     if (res.key == 'checkbox') {
                //         groupForm.get(`${res.key}`).setValue(res.Default == 'true' ? true : false);
                //     } else if (res.type == 'select' && res?.Default) {
                //         groupForm.get(`${res.key}`).setValue(res?.Default);
                //     }
                //     //  else {
                //     //     groupForm.get(`${res.key}`).setValue(res?.Default[0]);
                //     // }
                // }
            }
        });
        return groupForm;
    }

    //method used when mesurement unit is changed
    UnitChanges(event, control: any, secName: string, groupName: string, index: number, tabName?: string, j?: number) {
        let groupForm = this.getFormGroup(secName, groupName, index, tabName, j);
        if (groupForm.get(control.key).value != '') {
            groupForm.get(control.key).setValue(parseFloat(groupForm.get(control.key).value).toFixed(+event.value.decimalPoint));
        }
    }

    //Getting line number formet by instancesaddControlmakip
    async getLineNumberFormet(controlName, groupname, sectionFormName, index: number, j?: number, tabName?: string) {
        let instanceId = localStorage.getItem('currentInstanceId');
        this.lineNumberFormet = [];
        this.ngxUiLoaderService.start();
        this.managementApiService
            .getLineNumberFormatByInstance(instanceId)
            .toPromise()
            .then(
                (res) => {
                    if (res.success === true) {
                        this.lineNumberFormet = res.response;

                        if (this.JsonDataContent && this.JsonDataContent[`${controlName}_selection`]) {
                            this.lineNumberFormatId = this.JsonDataContent[`${controlName}_selection`];
                            this.lineNumberFormetSection = this.JsonDataContent[`${controlName}`];

                            this.selectedLineNumberFormate = this.lineNumberFormet.find(
                                (x) => x.lineNumberFormatId == this.JsonDataContent[`${controlName}_selection`]
                            );
                        } else {
                            this.lineNumberFormetSection = this.lineNumberFormet.find((l) => l.isDefault).sections;
                            this.lineNumberFormatId = this.lineNumberFormet.find((l) => l.isDefault).lineNumberFormatId;
                            this.selectedLineNumberFormate = this.lineNumberFormet.find((l) => l.isDefault);
                        }

                        let lineNumberForm = new UntypedFormArray([]);
                        if (this.selectedLineNumberFormate.allowFreeForm) {
                            let freeData: UntypedFormGroup = new UntypedFormGroup({
                                value: new UntypedFormControl(this.lineNumberFormetSection[0]?.value ? this.lineNumberFormetSection[0]?.value : ''),
                            });
                            lineNumberForm.push(freeData);
                        } else {
                            this.lineNumberFormetSection.map((l) => lineNumberForm.push(this.initFormArrayForLineNumberFormat(l)));
                        }

                        let groupForm = this.getFormGroup(sectionFormName, groupname, index, tabName, j);
                        groupForm.addControl(
                            `${controlName}_selection`,
                            this.formBuilder.control(this.JsonDataContent ? this.JsonDataContent[`${controlName}_selection`] : this.lineNumberFormatId)
                        );
                        groupForm.addControl(`${controlName}`, lineNumberForm);
                        this.linenumberControlname = controlName;
                        this.ngxUiLoaderService.stop();
                    } else {
                        this.user_utlity.errorModelPopup(res.message);
                        this.ngxUiLoaderService.stop();
                    }
                },
                (err) => {
                    this.ngxUiLoaderService.stop();
                    this.user_utlity.errorModelPopup('Something went wrong !!');
                }
            );
    }

    getFormGroup(sectionFormName, groupname, index, tabName?: string, j?: number): UntypedFormGroup {
        let sectionForm;
        let tabForm;
        if (this.jsonObject[0].type.toLowerCase() == 'section') {
            sectionForm = this.schemsForm.get(sectionFormName) as UntypedFormArray;
            return sectionForm.controls[index].get(groupname) as UntypedFormGroup;
        } else if (this.jsonObject[0].type.toLowerCase() == 'tab') {
            tabForm = this.schemsForm.get(tabName) as UntypedFormArray;
            sectionForm = tabForm.controls[index] as UntypedFormArray;
            return sectionForm.controls[j].get(groupname) as UntypedFormGroup;
        }
    }

    //For intilize formGroup of lineNumber Formate
    initFormArrayForLineNumberFormat(x): UntypedFormGroup {
        let validators = [
            Validators.required,
            Validators.minLength(x.minLength ? x.minLength : x.minlength),
            Validators.maxLength(x.maxLength ? x.maxLength : x.maxlength),
        ];

        switch (true) {
            case x?.allowNumeric && x?.allowAlpha:
            case x?.allownumeric && x?.allowalpha:
                break;

            case x?.allowNumeric:
            case x?.allownumeric:
                validators.push(Validators.pattern('^[0-9]+'));
                break;

            case x?.allowAlpha:
            case x?.allowalpha:
                validators.push(Validators.pattern('[a-zA-Z]+'));
                break;
        }

        let lineNumberValue = '';

        if (typeof this.JsonDataContent?.linenumber !== 'string' && this.PageType != PageType.PlantManagerCopy) {
            lineNumberValue = this.JsonDataContent?.linenumber.find((item) => item?.lineNumberFormatSectionId == x?.lineNumberFormatSectionId)?.value;
        }

        return new UntypedFormGroup({
            lineNumberFormatSectionId: new UntypedFormControl(x?.lineNumberFormatSectionId ? x?.lineNumberFormatSectionId : x.linenumberformatsectionid, []),
            name: new UntypedFormControl(x?.name, []),
            value: new UntypedFormControl(lineNumberValue ? lineNumberValue : '', validators),
            allowAlpha: new UntypedFormControl(x?.allowAlpha ? x?.allowAlpha : x.allowalpha, []),
            allowNumeric: new UntypedFormControl(x?.allowNumeric ? x?.allowNumeric : x?.allownumeric, []),
            editedDate: new UntypedFormControl(x?.editedDate ? x?.editedDate : x?.editeddate, []),
            index: new UntypedFormControl(x?.index, []),
            maxLength: new UntypedFormControl(x?.maxLength ? x?.maxLength : x?.maxlength, []),
            minLength: new UntypedFormControl(x?.minLength ? x?.minLength : x?.minlength, []),
        });
    }

    //When Line Formet is changed
    LineFormatChange(event, item, secName, groupName, index, tabName?: string, j?: number) {
        let groupForm = this.getFormGroup(secName, groupName, index, tabName, j);
        let formArray = groupForm.get('linenumber') as UntypedFormArray;
        formArray.clear();

        this.selectedLineNumberFormate = this.lineNumberFormet.find((x) => x.lineNumberFormatId == event.value);
        this.lineNumberFormetSection = this.lineNumberFormet.find((x) => x.lineNumberFormatId == event.value).sections;
        this.lineNumberFormatId = this.lineNumberFormet.find((x) => x.lineNumberFormatId == event.value).lineNumberFormatId;
        groupForm.get(`${item.key}_selection`).setValue(this.lineNumberFormatId);
        if (this.selectedLineNumberFormate.allowFreeForm) {
            let freeData: UntypedFormGroup = new UntypedFormGroup({
                value: new UntypedFormControl(this.lineNumberFormetSection[0]?.value ? this.lineNumberFormetSection[0]?.value : ''),
            });
            formArray.push(freeData);
        } else {
            this.lineNumberFormetSection.map((x) => formArray.push(this.initFormArrayForLineNumberFormat(x)));
        }
    }

    CalculationtypeChanged(event) {
        this.calcType = event.value;
    }

    async OpenJointCalcModel() {
        console.log(this.schemsForm);
        this.isjointcalcOpen = true;
        let id = this.plantmanagerService.selectedline?.taggedItemId
            ? this.plantmanagerService.selectedline?.taggedItemId
            : this.trail
              ? this.trail[this.trail.length - 2]?.id || this.trail[this.trail.length - 2]?.taggedItemId
              : null;
        if (id) {
            let resp = await this.idmApiService.GetTaggedItemDataById(id).toPromise();
            if (resp) {
                this.barCodeNumber = resp.response.barCodeNumber;
                this.jointCalcService.pipeSpecpayload = new PipeSpecpayload();
                this.jointCalcService.pipeSpecpayload.lookupParams = new InputGroup();

                if (resp.response?.lineNumberFormat?.sections && resp.response?.lineNumberFormat?.sections.length) {
                    let pipeSpecIndex = resp.response?.lineNumberFormat?.sections.findIndex((x, i) => x.type.index == 2);

                    let pipeCode = resp.response.namePrimary.split('-')[pipeSpecIndex];

                    if (pipeCode != null || pipeCode != undefined) {
                        this.jointCalcService.pipeSpecpayload.pipeCode = pipeCode;
                        this.jointCalcService.pipeSpecpayload.lookupParams.calculationType = this.calcType;
                        let pipeCodeList = await this.idmApiService.findpipespecs(this.jointCalcService.pipeSpecpayload).toPromise();
                        if (pipeCodeList.success && pipeCodeList?.response?.length) {
                            this.jointCalcService.pipeSpecList = pipeCodeList?.response;
                            this.jointCalcService.PipeSpecFilteredList = pipeCodeList?.response;
                            this.jointCalcService.isPipeCode = true;
                            this.jointCalcService.ispipeSpec.emit(true);
                        }
                    }
                }
            }
        }
        let dialogRef = this.modelService.open(JointCalculationModelComponent, {
            size: 'lg',
            backdrop: 'static',
        });
        dialogRef.componentInstance.i = this.jointCalcService?.pipeSpecpayload?.pipeCode ? true : false;

        dialogRef.componentInstance.taggedItem = this.TaggedItemData;
        dialogRef.componentInstance.calculationType = Number(this.calcType);
        dialogRef.componentInstance.selectedTool = this.selectedTool;
        if (this.PageType == PageType.PlantManagerCreate) dialogRef.componentInstance.PageMethod = 'Create';
        else dialogRef.componentInstance.PageMethod = '';
        dialogRef.componentInstance.CalculationResultString.subscribe((data: any) => {
            if (data) {
                this.PlantManagerSaveObj.CalculationResult = data.calculationResultString;
                this.fncalculationResult.emit(data.calculationResult);
                this.showPrint = true;
                this.cd.detectChanges();
            } else {
                if (!this.PlantManagerSaveObj.CalculationResult) {
                    let calcString = { type: this.calcType };
                    this.PlantManagerSaveObj.CalculationResult = JSON.stringify(calcString);
                }
            }
        });
        if (this.PlantManagerSaveObj.CalculationResult) {
            dialogRef.componentInstance.calculationResult =
                typeof this.PlantManagerSaveObj.CalculationResult == 'string'
                    ? JSON.parse(this.PlantManagerSaveObj.CalculationResult.replace(/\$Inch\$/g, '"'))
                    : this.PlantManagerSaveObj.CalculationResult;
        }

        dialogRef.result
            .then((result) => {
                if (this.jointCalcService.PipeSpecFilteredList.length) {
                    this.pipeSpecVersionId = this.jointCalcService.PipeSpecFilteredList[0].pipeSpecVersionId;
                }
                this.jointCalcService.pipeSpecpayload?.lookupParams ? (this.jointCalcService.pipeSpecpayload.lookupParams = null) : '';
                this.jointCalcService.pipeSpecpayload?.pipeCode ? (this.jointCalcService.pipeSpecpayload.pipeCode = null) : '';
                this.jointCalcService?.pipeSpecpayload ? (this.jointCalcService.pipeSpecpayload = null) : '';
                this.jointCalcService?.pipeSpecList ? (this.jointCalcService.pipeSpecList = []) : '';
                this.jointCalcService.PipeSpecFilteredList ? (this.jointCalcService.PipeSpecFilteredList = []) : '';
                this.jointCalcService?.isPipeCode ? (this.jointCalcService.isPipeCode = false) : '';

                this.jointCalcService.pipeSpecpayload = new PipeSpecpayload();
                this.jointCalcService.pipeSpecpayload.lookupParams = new InputGroup();

                this.jointCalcService.ispipeSpec.next(null);
                this.jointCalcService.selectedLubricant.next(null);
                this.jointCalcService.selectedStandard.next(null);
                this.jointCalcService.selectedPressureClass.next(null);
                this.jointCalcService.selectedpipeSize.next(null);
                this.jointCalcService.selectedflangeType.next(null);
                this.jointCalcService.selectedflangeFacingType.next(null);
                this.jointCalcService.selectedgasket.next(null);
                this.jointCalcService.selectedBoltType.next(null);
                this.jointCalcService.selectedboltMaterial.next(null);
                this.jointCalcService.selectedflangeMaterial.next(null);
                this.jointCalcService.selectedTighteningSpecification.next(null);
                this.jointCalcService.selectedclampMaterial.next(null);
                this.jointCalcService.selectedhubMaterial.next(null);
                this.jointCalcService.selectedPipeSchedule.next(null);
                this.jointCalcService.selectedClampManufacturer.next(null);
                this.jointCalcService.selectedClampSize.next(null);
                this.jointCalcService.selectedsealRingMaterial.next(null);
                this.jointCalcService.selectedsealRingId.next(null);

                this.jointCalcService.pipeSpecpayload = new PipeSpecpayload();
                this.dataservice.calculationData = null;
                this.isjointcalcOpen = false;
            })
            .catch((error) => {
                this.isjointcalcOpen = false;
                console.error('Modal dismissed', error);
            });
    }

    consoleForm() {
        console.warn('++++++++++++++++>', this.schemsForm);
    }

    onUpload(event) {
        for (const file of event.files) {
            this.uploadedFiles.push(file);
        }

        this.messageService.add({
            severity: 'info',
            summary: 'File Uploaded',
            detail: '',
        });
    }

    fileChangeEvent(event: any): void {
        if (!event?.target?.files || event.target.files.length === 0) {
            return;
        }

        const files: FileList = event.target.files;

        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];

        // Store event if you're using it for a cropper
        this.imageChangedEvent = event;

        // Validate all selected files
        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            if (!allowedTypes.includes(file.type)) {
                this.customToastService.errorToast('Please select only .jpeg, .jpg, .png, or .webp files.', 'Error');
                return;
            }
        }

        // If validation passed, open modal
        this.ImageModalOpen(event);

        this.schemsForm.markAsDirty();
        this.schemsForm.markAllAsTouched();
    }

    createBlobUrl(base64String: string) {
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/octet-stream' });

        return URL.createObjectURL(blob);
    }

    ImageModalOpen(event: any, i?: number) {
        let dialogRef = this.modelService.open(ImageCropModelComponent, {
            backdrop: 'static',
            size: 'lg',
        });
        dialogRef.componentInstance.imageChangedEvent = event;
        dialogRef.componentInstance.JointData = this.TaggedItemData;
        dialogRef.componentInstance.imgType = 'carousel';
        dialogRef.componentInstance.ratio = 16 / 9;
        this.images.length ? (dialogRef.componentInstance.ImageArray = this.images) : [];
        dialogRef.componentInstance.index = i;
        dialogRef.result
            .then((response) => {
                if (response) {
                    this.images = response;
                    this.PlantManagerSaveObj.IsImageChanged = true;
                    this.schemsForm.markAsDirty();
                    this.schemsForm.markAsTouched();
                    // this.cd.detectChanges();
                }
            })
            .catch((e) => {
                console.warn(e);
            });
    }

    deleteImage(i: number) {
        this.images.splice(i, 1);
        this.schemsForm.markAsDirty();
        this.schemsForm.markAsTouched();
    }

    editImages(i: number) {
        this.ImageModalOpen(this.images.map((x) => x.file));
    }

    openFileExp() {
        this.imageUpload.nativeElement.click();
        this.cd.detectChanges();
    }

    onSelectFile(event: any) {
        if (!event?.target?.files || event.target.files.length === 0) {
            return;
        }

        const files: FileList = event.target.files;
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];

        // ✅ Validate all selected files
        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            if (!allowedTypes.includes(file.type)) {
                this.customToastService.errorToast('Please select only .jpeg, .jpg, .png, or .webp files.', 'Error');
                return; // stop execution if any invalid file found
            }
        }

        // ✅ Open modal only after validation success
        let dialogRef = this.modelService.open(ImageCropModelComponent, {
            backdrop: 'static',
            size: 'lg',
        });

        dialogRef.componentInstance.imageChangedEvent = event;
        dialogRef.componentInstance.imgType = 'logo';
        dialogRef.componentInstance.ratio = 1;

        if (this.images?.length) {
            dialogRef.componentInstance.ImageArray = this.images;
        }

        dialogRef.result
            .then((response) => {
                if (response && response.length) {
                    this.imageUrl = response[0].url;
                    this.selectedImage = response[0].file;
                    this.cd.detectChanges();
                    this.schemsForm.markAsDirty();
                    this.schemsForm.markAsTouched();
                }
            })
            .catch((e) => {
                console.warn(e);
            });
    }

    async handleFileSelect(event: any, i: number) {
        this.imageChangedEvent = event;
        this.ImageModalOpen(event, i);
        this.cd.detectChanges();
    }

    deleteLogoImg() {
        this.imageUrl = null;
        this.PlantManagerSaveObj.ImageUrl = '';
        this.schemsForm.markAsDirty();
        this.schemsForm.markAsTouched();
    }

    closeClick() {
        this.ngbActiveModal.close();
    }

    searchResult(event, item) {
        return (item.userList = item.userListCopy.filter((item) => {
            return (item.fullName !== undefined ? item.fullName : '').toLowerCase().trim().includes(event.target.value.trim().toLowerCase());
        }));
    }

    async upgradeToLatestSchema() {
        if (
            (this.PageType as PageType) == PageType.EditLeakItem ||
            (this.PageType as PageType) == PageType.EditExceptionItem ||
            (this.PageType as PageType) == PageType.ExceptionEditWithLatestSchema ||
            (this.PageType as PageType) == PageType.LeakEditWithLatestSchema
        ) {
            if (this.Tab == 1) {
                this.jsonString = this.AdditionalInfo.latestDetailsSchema;
                this.AdditionalInfo.DetailsSchemaVersionId = this.AdditionalInfo.detailsLatestSchemaVersionId;
            } else if (this.Tab == 2) {
                this.jsonString = this.AdditionalInfo.latestLeakOrExceptionSchema;
                this.AdditionalInfo.LeakOrExceptionschemaVersionId = this.AdditionalInfo.LeakOrExceptionLatestSchemaVersionId;
            }
            // this.PageType = PageType.LeakOrExceptionEditWithLatestSchema;
            // this.AdditionalInfo.PageType = PageType.LeakOrExceptionEditWithLatestSchema;
            await this.setUpAndInitControls();
            this.IsLeakOrExceptionVersionUpgrade = false;
        } else {
            // this.updatelatestVersion.emit(this.TaggedItemData);
            this.ngxUiLoaderService.start();
            let id;
            if (this.PageType == PageType.PlantManagerEdit) {
                id = this.TaggedItemData.latestSchemaVersionId;
                this.plantmanagerService.LatestVersionTaggedItemId = this.TaggedItemData.latestSchemaVersionId;
            }
            if (this.PageType == PageType.ProjectManagerEdit) id = this.projectDetails.schemaVersion.latestSchemaVersionId;
            if (this.PageType == PageType.ActivityPackEdit) id = this.activityPackDetails.schemaVersion.latestSchemaVersionId;
            if (this.PageType == PageType.EditActivityTaggedItem) id = this.activityPackRecordDetails.activityPackTaggedItemActivityLatestSchemaVersionId;
            this.managementApiService.GetSchemaVersions(id, localStorage.getItem('currentInstanceId')).subscribe(
                (res) => {
                    if (res.success) {
                        this.plantmanagerService.updatedSchema.next(res.response.schema);
                    } else {
                        this.user_utlity.errorModelPopup(res.message);
                    }
                    this.ngxUiLoaderService.stop();
                },
                (error) => {
                    this.ngxUiLoaderService.stop();
                }
            );
        }

        this.schemsForm.markAsDirty();
        this.schemsForm.markAsTouched();
    }

    showJointtightening() {
        let dialogRef = this.modelService.open(JointTighteningGenericComponent, {
            size: 'lg',
        });
        if (this.PlantManagerSaveObj.CalculationResult) {
            dialogRef.componentInstance.calculationResult = JSON.parse(this.PlantManagerSaveObj.CalculationResult.replace(/\$Inch\$/g, '"'));
        }
    }

    LoadCalcResult() {
        return typeof this.PlantManagerSaveObj.CalculationResult == 'string'
            ? JSON.parse(this.PlantManagerSaveObj.CalculationResult.replace(/\$Inch\$/g, '"'))
            : this.PlantManagerSaveObj.CalculationResult;
    }

    measurentValueChange(event, item, Group: FormGroup) {
        if (typeof Group.get('value') == 'number') {
            item.DisplayUnit.forEach((x: any) => {
                if (x.key == Group.get('unit').value && Group.get('value').value && x.decimalPoint != null) {
                    Group.get('value').setValue(parseFloat(Group.get('value').value).toFixed(x.decimalPoint));
                }
            });
        }
    }

    async LoadPassValues() {
        if ((this.tighteningMethod == 0 && this.selectedTool?.isPowered == true) || this.tighteningMethod == 1) {
            await this.loadPumpPressure();
        }
        if (this.tighteningMethod == 0) {
            await this.loadTorque();
        }
    }

    createForm() {
        return this.formBuilder.group({
            toolid: [this.selectedToolId],
            tighteningmethod: [this.tighteningMethod == 0 ? 'Torque' : 'Tension'],
            toolingvalueas: [this.ToolingValue],
            boltstress: [this.resBoltStress],

            torqueapplied: this.formBuilder.group({
                unit: [this.selectedTorqueUnit],
                passvalues: this.createPassValuesFormArray(this.TorquePassValues),
            }),
            pressureapplied: this.formBuilder.group({
                unit: [this.selectedTensionUnit],
                passvalues: this.createPassValuesFormArray(this.PumpPressurepassValues),
            }),
        });
    }

    createPassValuesFormArray(passValuesArray: { key: string; value: string }[]): FormArray {
        const passValuesFormArray = this.formBuilder.array([]);
        if (passValuesArray) {
            passValuesArray.forEach((passValue) => {
                passValuesFormArray.push(
                    this.formBuilder.group({
                        key: [passValue.key],
                        value: [passValue.value],
                    })
                );
            });
        }

        return passValuesFormArray;
    }

    async loadPumpPressure() {
        this.PumpPressurepassValues = [];
        if (this.calcResult !== null) {
            if (this.tighteningMethod == TighteningMethod.Tension) {
                //Pass1
                if (this.selectedTool?.pass1 != undefined && this.selectedTool?.pass1 != null && this.calcResult?.output?.general.torquePercentageText1) {
                    this.PumpPressurepassValues.push({
                        key: this.calcResult?.output?.general.torquePercentageText1 ? this.calcResult?.output?.general.torquePercentageText1 : 'Pass 1',
                        value: parseFloat(
                            this.selectedTensionUnit.toUpperCase() == 'BAR'
                                ? this.selectedTool.pass1.metric.stringValue.replace(/,/g, '')
                                : this.selectedTool.pass1.imperial.stringValue.replace(/,/g, '')
                        ),
                    });
                }

                //Pass2
                if (this.selectedTool?.pass2 != undefined && this.selectedTool?.pass2 != null && this.calcResult?.output?.general.torquePercentageText2) {
                    this.PumpPressurepassValues.push({
                        key: this.calcResult?.output?.general.torquePercentageText2 ? this.calcResult?.output?.general.torquePercentageText2 : 'Pass 2',

                        value: parseFloat(
                            this.selectedTensionUnit.toUpperCase() == 'BAR'
                                ? this.selectedTool.pass2.metric.stringValue.replace(/,/g, '')
                                : this.selectedTool.pass2.imperial.stringValue.replace(/,/g, '')
                        ),
                    });
                }
                //Pass3
                if (this.selectedTool?.pass3 != undefined && this.selectedTool?.pass3 !== null && this.calcResult?.output?.general.torquePercentage3) {
                    this.PumpPressurepassValues.push({
                        key: this.calcResult?.output?.general.torquePercentageText3 ? this.calcResult?.output?.general.torquePercentageText3 : 'Pass 3',

                        value: parseFloat(
                            this.selectedTensionUnit.toUpperCase() == 'BAR'
                                ? this.selectedTool.pass3.metric.stringValue.replace(/,/g, '')
                                : this.selectedTool.pass3.imperial.stringValue.replace(/,/g, '')
                        ),
                    });
                }
                //Pass4
                if (this.selectedTool?.pass4 != undefined && this.selectedTool?.pass4 !== null && this.calcResult?.output?.general.torquePercentageText4) {
                    this.PumpPressurepassValues.push({
                        key: this.calcResult?.output?.general.torquePercentageText4 ? this.calcResult?.output?.general.torquePercentageText4 : 'Pass 4',

                        value: parseFloat(
                            this.selectedTensionUnit.toUpperCase() == 'BAR'
                                ? this.selectedTool.pass4.metric.stringValue.replace(/,/g, '')
                                : this.selectedTool.pass4.imperial.stringValue.replace(/,/g, '')
                        ),
                    });
                }
            } else {
                let isPass1 = this.calcResult?.output?.general.torquePercentageText1;
                let isPass2 = this.calcResult?.output?.general.torquePercentageText2;
                let isPass3 = this.calcResult?.output?.general.torquePercentageText3;
                let isPass4 = this.calcResult?.output?.general.torquePercentageText4;

                if (this.selectedTool?.requiredPressure1 !== null && isPass1) {
                    const val = this.calcResult.output.general;

                    let perc = parseFloat(
                        this.selectedTensionUnit.toUpperCase() == 'BAR'
                            ? this.selectedTool?.requiredPressure1.metric.stringValue.replace(/,/g, '')
                            : this.selectedTool?.requiredPressure1.imperial.stringValue.replace(/,/g, '')
                    );
                    this.PumpPressurepassValues.push({
                        key: this.calcResult?.output?.general.torquePercentageText1 ? this.calcResult?.output?.general.torquePercentageText1 : 'Pass 1',

                        value: perc,
                    });
                } else if (this.selectedTool?.maximumPressure !== null && isPass1) {
                    let perc =
                        (parseFloat(
                            this.selectedTensionUnit.toUpperCase() == 'BAR'
                                ? this.selectedTool?.maximumPressure.metric.stringValue.replace(/,/g, '')
                                : this.selectedTool?.maximumPressure.imperial.stringValue.replace(/,/g, '')
                        ) *
                            parseFloat(this.managementApiService.userDefaults.find((x) => x.userPreferenceKey == 'Calculation_Pass1_Value').userPreference)) /
                        100;
                    this.PumpPressurepassValues.push({
                        key: this.calcResult?.output?.general.torquePercentageText1 ? this.calcResult?.output?.general.torquePercentageText1 : 'Pass 1',

                        value: perc,
                    });
                }

                if (this.selectedTool?.requiredPressure2 !== null && isPass2) {
                    let perc = parseFloat(
                        this.selectedTensionUnit.toUpperCase() == 'BAR'
                            ? this.selectedTool?.requiredPressure2.metric.stringValue.replace(/,/g, '')
                            : this.selectedTool?.requiredPressure2.imperial.stringValue.replace(/,/g, '')
                    );
                    this.PumpPressurepassValues.push({
                        key: this.calcResult?.output?.general.torquePercentageText2 ? this.calcResult?.output?.general.torquePercentageText2 : 'Pass 2',

                        value: perc,
                    });
                } else if (this.selectedTool?.maximumPressure !== null && isPass2) {
                    let perc =
                        (parseFloat(
                            this.selectedTensionUnit.toUpperCase() == 'BAR'
                                ? this.selectedTool?.maximumPressure.metric.stringValue.replace(/,/g, '')
                                : this.selectedTool?.maximumPressure.imperial.stringValue.replace(/,/g, '')
                        ) *
                            parseFloat(this.managementApiService.userDefaults.find((x) => x.userPreferenceKey == 'Calculation_Pass2_Value').userPreference)) /
                        100;
                    this.PumpPressurepassValues.push({
                        key: this.calcResult?.output?.general.torquePercentageText2 ? this.calcResult?.output?.general.torquePercentageText2 : 'Pass 2',

                        value: perc,
                    });
                }

                if (this.selectedTool?.requiredPressure3 !== null && isPass3) {
                    let perc = parseFloat(
                        this.selectedTensionUnit.toUpperCase() == 'BAR'
                            ? this.selectedTool?.requiredPressure3.metric.stringValue.replace(/,/g, '')
                            : this.selectedTool?.requiredPressure3.imperial.stringValue.replace(/,/g, '')
                    );
                    this.PumpPressurepassValues.push({
                        key: this.calcResult?.output?.general.torquePercentageText3 ? this.calcResult?.output?.general.torquePercentageText3 : 'Pass 3',

                        value: perc,
                    });
                } else if (this.selectedTool?.maximumPressure !== null && isPass3) {
                    let perc =
                        (parseFloat(
                            this.selectedTensionUnit.toUpperCase() == 'BAR'
                                ? this.selectedTool?.maximumPressure.metric.stringValue.replace(/,/g, '')
                                : this.selectedTool?.maximumPressure.imperial.stringValue.replace(/,/g, '')
                        ) *
                            parseFloat(this.managementApiService.userDefaults.find((x) => x.userPreferenceKey == 'Calculation_Pass3_Value').userPreference)) /
                        100;
                    this.PumpPressurepassValues.push({
                        key: this.calcResult?.output?.general.torquePercentageText3 ? this.calcResult?.output?.general.torquePercentageText3 : 'Pass 3',

                        value: perc,
                    });
                }
                if (this.selectedTool?.requiredPressure4 !== null && isPass4) {
                    let perc = parseFloat(
                        this.selectedTensionUnit.toUpperCase() == 'BAR'
                            ? this.selectedTool?.requiredPressure4.metric.stringValue.replace(/,/g, '')
                            : this.selectedTool?.requiredPressure4.imperial.stringValue.replace(/,/g, '')
                    );
                    this.PumpPressurepassValues.push({
                        key: this.calcResult?.output?.general.torquePercentageText4 ? this.calcResult?.output?.general?.torquePercentageText4 : 'Pass 4',

                        value: perc,
                    });
                } else if (this.selectedTool?.maximumPressure !== null && isPass4) {
                    let perc =
                        (parseFloat(
                            this.selectedTensionUnit.toUpperCase() == 'BAR'
                                ? this.selectedTool?.maximumPressure.metric.stringValue.replace(/,/g, '')
                                : this.selectedTool?.maximumPressure.imperial.stringValue.replace(/,/g, '')
                        ) *
                            parseFloat(this.managementApiService.userDefaults.find((x) => x.userPreferenceKey == 'Calculation_Pass4_Value').userPreference)) /
                        100;
                    this.PumpPressurepassValues.push({
                        key: this.calcResult?.output?.general.torquePercentageText4 ? this.calcResult?.output?.general.torquePercentageText4 : 'Pass 4',

                        value: perc,
                    });
                }

                // this.isToolChanged = false;
            }
        }

        console.log(this.PumpPressurepassValues);
    }

    checkUserprefrences(userPrefferd) {
        return this.managementApiService.userDefaults.find((item) => item.userPreferenceKey == userPrefferd).userPreference === 'True' ? true : false;
    }

    async loadTorque() {
        if (this.tighteningMethod !== TighteningMethod.Torque) return;

        this.TorquePassValues = [];

        const unitType = this.selectedTorqueUnit === 'Nm' ? 'metric' : 'imperial';
        const passes = [1, 2, 3, 4];

        for (const pass of passes) {
            if (this.checkPreferenceText(`torquePercentageText${pass}`)) {
                const key = this.getPreferenceText(`torquePercentageText${pass}`);
                //const value = this.getPreferenceText(`torquePercentage${pass}`);
                const value = this.getTorqueValue(pass, unitType);
                this.TorquePassValues.push({ key, value });
            }
        }

        console.log(this.TorquePassValues);
    }

    private checkPreferenceText(key: string): string {
        const general = this.calcResult.output.general;
        return general[key];
    }

    private getPreferenceText(key: string): string {
        const general = this.calcResult.output.general;
        return general[key];
    }

    private getUserPreferenceText(key: string): string {
        return this.managementApiService.userDefaults.find((x) => x.userPreferenceKey === key)?.userPreference ?? '';
    }

    private getTorqueValue(pass: number, unit: 'metric' | 'imperial'): number {
        const general = this.calcResult.output.general;
        const longForm = general[`torqueLongForm${pass}`]?.[unit]?.stringValue;
        const shortForm = general[`torqueShortForm${pass}`]?.[unit]?.stringValue;
        // const mode = this.calcResult?.input?.others?.lubricantMode == '0';

        // const valueStr = longForm?.replace(/,/g, '') ?? shortForm?.replace(/,/g, '') ?? '0';
        const valueStr = this.calcResult?.input?.others?.lubricantMode ? shortForm?.replace(/,/g, '') : longForm?.replace(/,/g, '');
        return parseFloat(valueStr);
    }

    private getPumpValue(pass: number, unit: 'BAR'): number {
        const general = this.calcResult.output.general;
        const val = general[`requiredPressure${pass}`]?.[unit]?.stringValue;
        return parseFloat(val);
    }

    selectedToolChange(selectedValue: MatSelectChange, itemkey, secKey, groupName, i, tabName, j, k): void {
        this.isToolChanged = true;
        const selection = this.calcResult?.output?.tools.find((x) => x.id === selectedValue.value);
        if (selection) {
            this.selectedTool = selection;
            this.selectedToolId = this.selectedTool.id;
            this.selectedTorqueUnit = 'Nm';
            if ((this.tighteningMethod == 0 && this.selectedTool?.isPowered == true) || this.tighteningMethod == 1) {
                this.loadPumpPressure();
            }
            if (this.tighteningMethod == 0) {
                this.loadTorque();
            }
            // this.LoadPassValues();

            let updatedForm = this.createForm();
            let group = this.getGroup(secKey, groupName, i, tabName, j, k);
            group.removeControl(itemkey);
            group.addControl(`${itemkey}`, updatedForm);
        }
    }

    getGroup(secKey, groupName, i, tabName, j, k) {
        if (this.jsonObjectCopy[0].type == 'section') {
            let sectionForm = this.schemsForm?.get(secKey) as UntypedFormArray;
            return sectionForm?.controls[i]?.get(groupName) as FormGroup;
        } else if (this.jsonObject[0].type == 'tab') {
            let tabForm = this.schemsForm.get(tabName) as UntypedFormArray;
            let sectionForm = tabForm.controls[j] as UntypedFormArray;
            return sectionForm.controls[k].get(groupName) as FormGroup;
        }
    }

    ToolingValueChangetorque(itemkey, secKey, groupName, i, tabName, j, k) {
        this.loadTorque();
        let updatedForm = this.createForm();
        let group = this.getGroup(secKey, groupName, i, tabName, j, k);
        group.removeControl(itemkey);
        group.addControl(`${itemkey}`, updatedForm);
    }

    ToolingValueChangeTension(itemkey, secKey, groupName, i, tabName, j, k) {
        this.loadPumpPressure();
        let updatedForm = this.createForm();
        let group = this.getGroup(secKey, groupName, i, tabName, j, k);
        group.removeControl(itemkey);
        group.addControl(`${itemkey}`, updatedForm);
    }

    torqueUnitChange(selectedValue, itemkey, secKey, groupName, i, tabName, j, k) {
        const value = selectedValue?.value ? selectedValue?.value : selectedValue;
        const selection = this.torqueUnitOptions.find((x) => x.value === value);
        if (selection) {
            this.selectedTorqueUnit = selection.value;
            this.loadTorque();
            let updatedForm = this.createForm();
            let group = this.getGroup(secKey, groupName, i, tabName, j, k);
            group.removeControl(itemkey);
            group.addControl(`${itemkey}`, updatedForm);
        }
    }

    tensionUnitChange(selectedValue, itemkey, secKey, groupName, i, tabName, j, k) {
        const value = selectedValue?.value ? selectedValue?.value : selectedValue;
        const selection = this.TensionUnitOptions.find((x) => x.value === value);
        if (selection) {
            this.selectedTensionUnit = selection.value;
            this.loadPumpPressure();
            let updatedForm = this.createForm();
            let group = this.getGroup(secKey, groupName, i, tabName, j, k);
            group.removeControl(itemkey);
            group.addControl(`${itemkey}`, updatedForm);
        }
    }

    toolValueChecked(event: any, itemkey, secKey, groupName, i, tabName, j, k) {
        this.ToolingValue = event.checked;

        if (this.ToolingValue) {
            this.ToolingValueChangetorque(itemkey, secKey, groupName, i, tabName, j, k);
            this.ToolingValueChangeTension(itemkey, secKey, groupName, i, tabName, j, k);

            // this.LoadPassValues();

            // this.torqueUnitChange(this.selectedTorqueUnit, itemkey, secKey, groupName, i, tabName, j, k);
            // this.tensionUnitChange(this.selectedTensionUnit, itemkey, secKey, groupName, i, tabName, j, k);
        } else {
            if (this?.JsonDataContent?.tighteningdetails?.torqueapplied?.passvalues && !this.ToolingValue && !this.isToolChanged) {
                this.TorquePassValues = this?.JsonDataContent?.tighteningdetails?.torqueapplied?.passvalues;
                let updatedForm = this.createForm();
                let group = this.getGroup(secKey, groupName, i, tabName, j, k);
                group.removeControl(itemkey);
                group.addControl(`${itemkey}`, updatedForm);
            } else {
                this.ToolingValueChangetorque(itemkey, secKey, groupName, i, tabName, j, k);
            }

            if (this?.JsonDataContent?.tighteningdetails?.pressureapplied?.passvalues && !this.ToolingValue && !this.isToolChanged) {
                this.PumpPressurepassValues = this?.JsonDataContent?.tighteningdetails?.pressureapplied?.passvalues;
                let updatedForm = this.createForm();
                let group = this.getGroup(secKey, groupName, i, tabName, j, k);
                group.removeControl(itemkey);
                group.addControl(`${itemkey}`, updatedForm);
            } else {
                this.ToolingValueChangeTension(itemkey, secKey, groupName, i, tabName, j, k);
            }
        }
        // this.cd.detectChanges();
    }

    applyValidators(res) {
        let validatorsArray = [];
        if (res.validators) {
            res.validators.forEach((validators) => {
                switch (validators.key) {
                    case 'min':
                        validatorsArray.push(Validators.min(validators.value));
                        break;
                    case 'max':
                        validatorsArray.push(Validators.max(validators.value));
                        break;
                    case 'required':
                        if (validators.value) {
                            validatorsArray.push(Validators.required);
                        }
                        break;
                    case 'minlength':
                        validatorsArray.push(Validators.minLength(validators.value));
                        break;
                    case 'maxlength':
                        validatorsArray.push(Validators.maxLength(validators.value));
                        break;
                    case 'pattern':
                        validatorsArray.push(Validators.pattern(validators.value));
                        break;

                    default:
                        break;
                }
            });
            if (res.IsNamePrimary || res.isnameprimary) {
                validatorsArray.push(Validators.required);
            }
            return validatorsArray;
        } else {
            if (res.IsNamePrimary || res.isnameprimary) {
                validatorsArray.push(Validators.required);
            }
            return validatorsArray;
        }
    }

    cancelClick() {
        if (this.mode == 'pop-up') {
            this.ngbActiveModal.close();
        } else {
            if (this.mode != 'pop-up') {
                if (this.projectmanagerService.selectedProjectData && this.router.url.match(/^\/idms\/project-manager\/([a-f0-9\-]+)$/)) {
                    this.router.navigate([`/idms/project-manager`]);
                } else if (
                    this.projectmanagerService.selectedWorkpackdata &&
                    this.router.url.match(/\/idms\/project-manager\/([a-f0-9\-]+)\/workpack\/([a-f0-9\-]+)/)
                ) {
                    let selectedProject = this.projectmanagerService.selectedProjectData;
                    this.router.navigate([`/idms/project-manager/${selectedProject.projectId}`]);
                }
                if (this.router.url.includes('idms/plantmanagerView')) {
                    this.router.navigate([`home`]);
                }
                this.projectmanagerService.currentProjectTab.next(null);
            }
            let allowedItem = this.TaggedItemData;
            if (this.TaggedItemData?.taggedItemType == 'Joint') {
                this.plantmanagerService.UpdateActiveTaggedItem.next(this.plantmanagerService.activeLineOrEquipmentTaggedItem);
            } else {
                this.plantmanagerService.UpdateActiveTaggedItem.next(allowedItem);
            }
        }
    }

    onTabChange(event) {
        this.selectedTabIndex = event.index;
        if (event.index === 0) {
            this.isSaveEnable = false;
        } else {
            this.isSaveEnable = true;
        }
    }

    compareDatesValidator(startDate: FormControl, endDate: FormControl): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!startDate || !endDate) {
                return null; // Valid if either date is missing
            }

            const start = new Date(startDate?.value);
            const end = new Date(endDate?.value);

            // Check for invalid dates
            if (isNaN(start.getTime()) || isNaN(end.getTime())) {
                return { invalidDate: true }; // Invalid dates
            }

            // Validate that startDate is less than or equal to endDate
            return start.getTime() <= end.getTime() ? null : { dateComparison: true };
        };
    }

    nextClick() {
        this.selectedTabIndex = 1;
    }

    backClick() {
        this.selectedTabIndex = 0;
    }

    enableCloseIcon() {
        if (
            (this.PageType as PageType) === PageType.AddLeakItem ||
            (this.PageType as PageType) === PageType.EditLeakItem ||
            (this.PageType as PageType) === PageType.ExceptionEditWithLatestSchema ||
            (this.PageType as PageType) === PageType.LeakEditWithLatestSchema ||
            (this.PageType as PageType) === PageType.AddExceptionItem ||
            (this.PageType as PageType) === PageType.EditExceptionItem
        ) {
            return false;
        } else {
            return true;
        }
    }

    IsVersionUpgradeData() {
        if (
            (this.PageType as PageType) === PageType.ActivityPackEditWithLatestSchema ||
            (this.PageType as PageType) === PageType.PlantManagerEditWithLatestSchema ||
            (this.PageType as PageType) === PageType.LeakEditWithLatestSchema ||
            (this.PageType as PageType) === PageType.ProjectManagerEditWithLatestSchema ||
            (this.PageType as PageType) === PageType.ExceptionEditWithLatestSchema ||
            (this.PageType as PageType) === PageType.ActivityTaggedItemEditWithLatestSchema
        ) {
            return true;
        } else {
            return false;
        }
    }

    async getJointIDSettingArea() {
        try {
            if (!this.settingArea) {
                // this.ngxUiLoaderService.start();
                let res = await this.managementApiService.getSettingProfileAreaId('iDMS').toPromise();

                if (res.success) {
                    this.settingArea = res.response;
                    await this.getInstanceSettings(); // * getting JOINT ID settings
                    //this.ngxUiLoaderService.stop();
                } else if (res.isCustom) {
                    //this.ngxUiLoaderService.stop();
                    this.user_utlity.errorModelPopup(res.message);
                }
            } else {
                await this.getInstanceSettings();
            }
        } catch (e) {
            this.ngxUiLoaderService.stop();
        }
    }

    async getInstanceSettings() {
        try {
            //this.ngxUiLoaderService.start();
            let settingsJd = await this.managementApiService
                .getInstanceDefaultSettings(this.settingArea.settingAreaId, localStorage.getItem('currentInstanceId'))
                .toPromise();

            if (settingsJd.success) {
                let Js: DefaultInstanceSettings = settingsJd.response.find((x) => x.userPreferenceKey == 'JointID');
                this.jointIdSetting = Js; //.setting.settingValues.find((val) => val.settingValueId == Js.settingValue.settingValueId);
                this.jointIdPrefixValue = settingsJd.response.find((x) => x.userPreferenceKey == 'JointIDPrefix');

                //this.ngxUiLoaderService.stop();
            } else if (settingsJd.isCustom) {
                //this.ngxUiLoaderService.stop();
                this.user_utlity.errorModelPopup(settingsJd.message);
            }
        } catch (e) {
            this.ngxUiLoaderService.stop();
        }
    }

    displayFn(user: any): string {
        return user && user.fullName ? user.fullName : '';
    }

    showBtnCancel() {
        return !this.router.url.includes('idms/plantmanagerView');
    }

    handleInputEvent(event: KeyboardEvent, typeOfValidation?: string) {
        this.customValidatorService.validateKeyPress(event, typeOfValidation);
    }

    // blockTyping(e: any) {
    //     // Allow only navigation and backspace so user can still click, tab etc
    //     const allowedKeys = ['Tab', 'Enter', 'Escape', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];

    //     if (!allowedKeys.includes(e.event?.key)) {
    //         e.event.preventDefault();
    //     }
    // }
    onCheckboxListChange(event: MatSelectionListChange, controlKey: string) {
        const values = event.source.selectedOptions.selected.map((o) => o.value);
        this.schemsForm.get(controlKey)?.setValue(values);
    }

    ngOnDestroy() {
        this.lineNumberFormatId = null;
        if (this.updateSchemasubscription) this.updateSchemasubscription.unsubscribe();
        if (this.calculationResultUpdatesubscription) this.calculationResultUpdatesubscription.unsubscribe();
        if (this.isSaveFromToolsubscription) this.isSaveFromToolsubscription.unsubscribe();
    }
}

export function checkboxValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        return control.value ? null : { checkboxRequired: true };
    };
}
